/* File: delivery.js
 * -----------------
 * File calculates the distances from Google APIs and accordingly gives the
 * user option for selecting delivery option and also calcualtes the prices
 * and various times for the delivery.
 */

import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './delivery.html';
import shippingOfferInfoIcon from './../../../images/shipping-info.png';
import shippingOfferAvailableIcon from './../../../images/shipping-tick.png';


@Component({
  controllerAs: 'delivery',
  template
})

export default class Delivery {
  static $inject = [
    '$scope',
    '$rootScope',
    '$ngRedux',
    '$state',
    '$uibModal',
    'toaster',
    'spinnerService',
    'authService',
    'orderService',
    '$q',
    '$window',
    '$cookies',
    '$stateParams',
    'APP',
    '$sce'
  ];

  constructor($scope, $rootScope, $ngRedux, $state, $uibModal, toaster, $spinner, $auth, $order, $q, $window, $cookies, $stateParams, APP, $sce) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$rootScope = $rootScope;
    this.$sce = $sce;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.toaster = toaster;
    this.$order = $order;
    this.$auth = $auth;
    this.giftCards = [];
    this.$spinner = $spinner;
    this.$q = $q;
    this.$stateParams = $stateParams;
    this.$cookies = $cookies;
    this.logoIcon = logoIcon;
    this.shippingOffer = {};
    this.shippingOffer.isOfferAvailable = false;
    this.shippingOffer.isOfferEligible = false;
    this.houseIcon = houseIcon;
    this.isMiscelleneousCategory = 4;
    this.giftCardMasterCodeStartsWith = '9';
    this.dscMasterCode = '88888888'; // Named constant
    this.noTimeForOrderReadyBy = false;
    // this.mode = 'In Store Pickup';
    this.mode = '';
    this.APP = APP;
    this.$window = $window;
    this.noItemsInCart = false;
    this.addressDetail = {};
    this.estimatedDeliveryDateTime = null;
    this.couponAmount = 0;
    this.couponNumber = null;
    this.example1model = [];
    this.multiselect_checkbox = { checkBoxes: true,idProperty: 'id' };
    this.isAddressValidated = false;
    this.showPopup = false;
    this.showPopupFee = false;
    this.erplyDis = [];
    // this.example1data = [ {id: 1, label: "David"}, {id: 2, label: "Jhon"}, {id: 3, label: "Danny"} ];
    // this.example3data = [{"id":0,"label":"1500100001022341","bbCouponAmount":null},{"id":1,"label":"1500100001036501","bbCouponAmount":null},{"id":2,"label":"1500100001046720","bbCouponAmount":null}];
    this.init();
    this.rateZoneRetryCount = 0;
    this.shippingOffer.thresholdAmount = 1500;
    this.shippingOfferInfoIcon = shippingOfferInfoIcon;
    this.shippingOfferAvailableIcon = shippingOfferAvailableIcon;
    this.taxableDiscountAmount = 0;
    this.calledTaxCount = 0;
    this.nextDayDelivery = 'Next Day Delivery';
    this.inStoreDelivery = 'In Store Pickup';
    this.instorePickupOnly = 'InStore';
    this.dropShipOnly = 'DropShip';
    this.isCurbside = false;
    this.isGiftOrder = false;
    this.hasCartError = false;
    this.fedexErrorMsg = "There seems to be a problem with your address. <br /> Please check your entry. Contact the store for assistance at <a class='blue-colored' href='tel:{{delivery.profile.store.phoneNumber}}'>{{delivery.profile.store.phoneNumber | telFormat}}</a>.";
    this.showDefaultFedexErrorMessage=true;
    this.promoLengthToBeShown=25;
    this.ordernotesPattern = "^[ a-zA-Z0-9~%!@#$^&*()_+={}|\\\\,.?:\"'\/:;<`>-]*$";
    // this.ordernotesPattern = `/^([\\\[\\\]a-zA-Z0-91234567890-=={};:<>,./?' |\\\s\\\\-])+$/`;
    $window.scrollTo(0, 0);

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      store: state.auth.storeDetail,
      cartDetail: state.order.cartDetail,
      shippingCharges: state.order.shippingCharges,
      cardInfo: state.order.paymentInfo,
      zoneDeliveryCharges: state.order.zoneDeliveryCharges,
      coupon: state.order.coupon,
      taxes: state.order.taxes,
      userShippingZone: state.order.userShippingZone,
      discountCoupon: state.order.discountCoupon,
      birdBucksList: state.order.birdBucksList,
      storeDiscountMap: state.order.storeDiscountMap,
      orderPoints: state.order.orderPoints,
      erplyShop: state.order.cartDetail.erplyShopCartResponse,
      erplyBirdBucksList: state.order.erplyBirdBucksList,
      shippingCountries: state.auth.countries,
      billingCountries: state.auth.countries
    };
  }

  init() {
    var ctrl = this;
    let { $spinner, $order, $q } = this;
    this.promise1 = $q.defer();
    this.cError = false;
    this.promise2 = $q.defer();
    this.couponAmount = 0;
    this.taxableDiscountAmount = 0;
    this.discountCouponAmount = 0;
    this.discountCode = null;
    this.appliedDiscountCoupon = sessionStorage.getItem('discountCoupon');
    this.appliedBirdBuckCoupon = sessionStorage.getItem('birdbuckCoupon');
    this.appliedErplyBBDiscount = sessionStorage.getItem('erplyBBDiscount');
    this.appliedErplyPromotionDiscount = sessionStorage.getItem('erplyPromotionDiscount');
    this.orderNotes = sessionStorage.getItem('orderNotesSession');

    if(!this.orderNotes || this.orderNotes=="undefined") {
      this.orderNotes = "";
    }

    if (this.taxes) {
      this.taxes.deliveryReceiptFee = 0;
    }
    if(this.erplyShop) {
      this.erplyShop.deliveryReceiptFee = 0;
    }
    console.log("appliedDiscountCoupon---",this.appliedDiscountCoupon);
    console.log("appliedBirdBuckCoupon---",this.appliedBirdBuckCoupon);
    // this.calculateClubPoints();

    //
    
    if(!this.appliedDiscountCoupon && !this.appliedBirdBuckCoupon){
      this.callTaxCount = 0;
    }

    else if (this.appliedDiscountCoupon && this.appliedBirdBuckCoupon){
      this.callTaxCount = 2;
    }
    else {
      this.callTaxCount = 1;
    }
    //

    let promise3 = $order.getCartDetail(false)
      .then(() => this.getUserProfile())
      .catch(err => {
        this.noItemsInCart = true;
        this.promise1.reject();
        this.promise2.reject();
        this.$auth.printCustomerGenericLogs(err);
      });
    let promise4 = $order.getShippingCharges();
    let promise5 = $order.getPaymentInfo();
    let promise6 = $order.getZoneWiseDeliveryCharges();
    let promise7 = $order.getStoreDiscountMapping();

    
    $spinner.show('appSpinner');
    let promises = [this.promise1.promise, this.promise2.promise, promise3, promise4, promise5, promise6, promise7];
    $q.all(promises)
      .then(() => {
        if (this.profile) {
          console.log("Checking profile has firstname : ", this.profile);
          if(!this.profile.store.hasErply){
            $order.getBirdBucksByUser(this.profile.userId);
          }
          else {
            if(this.cartContainsDsc()){
              this.$order.dscPremembership();
            }
            $order.getErplyBirdBucksByUser().then(() => {
              this.setSelectedBBCoupons();
            })
            .catch(err => {
              this.removeErplyBBDiscountCookie();
              console.log("Something went wrong in selecting Erply BB coupon");
              this.$auth.printCustomerGenericLogs(err);
            });
            this.setErplyPromotionCodes();
          }
        }

        // For non erply store we save discount coupon code in appliedDiscountCoupon
        // For Erply store we save code in appliedErplyPromotionDiscount
        if (this.appliedDiscountCoupon) {
          this.mobileDiscountCoupon = this.appliedDiscountCoupon;
          this.discountCouponCode = this.appliedDiscountCoupon;
          this.checkDiscountCoupon({ $error: {}, $$success: {}, $pending: undefined, $name: "discountCouponForm", $dirty: false }, this.appliedDiscountCoupon, false);
        }
        else {
          this.discountCoupon = null;
         // this.getTax();
        }

        // For non erply store we save discount coupon code in appliedBirdBuckCoupon
        // For Erply store we save code in appliedErplyBBDiscount
        if (this.appliedBirdBuckCoupon) {
          this.mobileCouponNumber = this.appliedBirdBuckCoupon;
          this.desktopCouponNumber = this.appliedBirdBuckCoupon;
          this.checkBirdbuck({ $error: {}, $$success: {}, $pending: undefined, $name: "couponForm", $dirty: false }, this.appliedBirdBuckCoupon, false);
        }
        else {
          this.couponAmount = 0;
          // this.getTax();
        }
        if(!this.appliedBirdBuckCoupon && !this.appliedDiscountCoupon){
          this.callingTax(0);
        }
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        this.calculateClubPoints();
        $spinner.hide('appSpinner');
      }
    );
  }

  // isApply is for either discount or BB coupon applied directly then call tax
  // isApply false is when page loads calls tax based on either BB or discount 
  callingTax(count,isApply){
    if(!isApply){
      this.calledTaxCount = this.calledTaxCount+count;
      if(this.callTaxCount==this.calledTaxCount){
        this.getTax();
      }
    } else {
      this.getTax();
    }
  }

  getUserProfile() {
    this.$auth.getUserProfile()
      .then(
      success => {
        this.$auth.getCountries().then(success => {
          this.getStates(this.profile.shippingCountry.countryCode,"shippingAddress",0);
        })
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        });

        if (this.$rootScope.tempdeliveryMode) {

          if (this.$rootScope.tempdeliveryMode === this.nextDayDelivery && this.cartContainsOnlyDsc()) {
            this.mode = this.inStoreDelivery;
            this.resetDeliveryMode(this.mode);
          } else {
            this.mode = this.$rootScope.tempdeliveryMode;
          }
          if (this.$rootScope.isCurbside) {
            this.isCurbside = this.$rootScope.isCurbside;
            this.curbSideDetails = this.$rootScope.curbSideDetails;
          }
        }
        else {
          this.mode = "";
        }

        // In store pickup only changes - when items contain deliverytype instore then hide shipping option
         if (this.cartDetail && this.cartDetail.cartItems && this.cartDetail.cartItems.length > 0) {
          const filteredInstoreItem = this.cartDetail.cartItems.filter(item => item.item.deliveryType === this.instorePickupOnly);
          if (filteredInstoreItem && filteredInstoreItem.length > 0) {
            this.filteredInstoreItem = true;
            this.mode = this.inStoreDelivery;
            this.resetDeliveryMode(this.mode);
          } else {
            this.filteredInstoreItem = false;
          }
          const filteredDropShipItem = this.cartDetail.cartItems.filter(item => item.item.deliveryType === this.dropShipOnly);
          if (filteredDropShipItem && filteredDropShipItem.length > 0) {
            this.filteredDropShipItem = true;
            this.mode = this.nextDayDelivery;
            this.resetDeliveryMode(this.mode);
          } else {
            this.filteredDropShipItem = false;
          }
         }

        let addressObj = localStorage.getItem('deliveryAddress');
        this.addressDetail = addressObj ? JSON.parse(addressObj) : success.data;
        if (!this.addressDetail.firstName) {
          this.addressDetail.firstName = this.addressDetail.customer.firstName;
          this.addressDetail.lastName = this.addressDetail.customer.lastName;
        }
        // console.log('addressDetail--');
        // console.log(this.addressDetail);
        this.$auth.getStoreDetail(success.data.store.storeURLName)
          .then(success => this.holidays = success.data.storeTimings.filter(e => e.isHoliday))
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          });
        // console.log('this.profile.billingAddressLine1---', this.profile.billingAddressLine1);
        // console.log('this.addressDetail.shippingAddressLine1---', this.addressDetail.shippingAddressLine1);
        this.calculateDeliveryOption();
        this.promise2.resolve();
      },
      () => {
        this.toaster.pop('success', 'We do not deliver at this address');
        this.promise2.reject();
        this.promise1.reject();
      }
      ).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }

  calculateDeliveryOption() {

    //  console.log(profile);
    var addressInfo = {
      'addressLine1': this.addressDetail.shippingAddressLine1,
      'city': this.addressDetail.shippingCity,
      'state': {
        'code': this.addressDetail.shippingState ? this.addressDetail.shippingState.code : ''
      },
      'zip': this.addressDetail.shippingZipCode,
      'country': this.addressDetail.shippingCountry
    };
    var ctrl = this;
    ctrl.rateZoneRetryCount++;
    this.notDeliverable = true;
    this.$order.getUserZone(addressInfo).then(() => {

      this.promise1.resolve();
      this.mode = (!this.mode || this.mode === 'Home Delivery') && !this.cartContainsOnlyDsc() ? this.nextDayDelivery : this.inStoreDelivery;
      this.notDeliverable = false;
      if (this.$rootScope.deliveryMode && !this.cartContainsOnlyDsc()) this.mode = this.$rootScope.deliveryMode;
      if (this.$rootScope.tempdeliveryMode) {
        this.mode = this.$rootScope.tempdeliveryMode;
      }
      else {
        this.mode = "";
      }
      // this.getTax();
    },
      error => {

        if (error.data.errorCode === 200) {
          if (ctrl.rateZoneRetryCount <= 3) {
            ctrl.calculateDeliveryOption();
          }
          else {
            ctrl.promise1.resolve();
            ctrl.notDeliverable = true;
          }
        } else if(error.data.errorCode === 676) {
          // Error Code 676 is Fedex Exception from WBU
          ctrl.promise1.resolve();
          ctrl.notDeliverable = true;
          if(error.data.message.includes("FedexError")){
            ctrl.fedexErrorMsg = error.data.message.split("|")[1];
            ctrl.showDefaultFedexErrorMessage=false;
          } else {
            ctrl.showDefaultFedexErrorMessage=true;
          }
        }
        else {
          ctrl.promise1.resolve();
          ctrl.notDeliverable = true;
        }
      }
    ).catch(err => {
      this.$auth.printCustomerGenericLogs(err);
    });

    /* const distanceService = new window.google.maps.DistanceMatrixService();
    const originAddr = profile.store.state
      ? `${profile.store.addressLine1}, ${profile.store.city}, ${profile.store.state.name}`
      : `${profile.store.addressLine1}, ${profile.store.city}`;
    const destAddr = addressDetail.shippingState
      ? `${addressDetail.shippingAddressLine1}, ${addressDetail.shippingCity}, ${addressDetail.shippingState.name}`
      : `${addressDetail.shippingAddressLine1}, ${addressDetail.shippingCity}`;
    distanceService.getDistanceMatrix(
      {
        origins: [originAddr],
        destinations: [destAddr],
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.IMPERIAL
      },
      (response, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          let distance = response.rows[0].elements[0].distance && response.rows[0].elements[0].distance.value / 1600;
          this.charge = this.shippingCharges.filter(el => {
            var min = el.distanceRange.split('-')[0];
            var max = el.distanceRange.split('-')[1];
            return min < distance && max > distance;
          });
          if (!this.charge.length || !distance) {
            this.notDeliverable = true;
          }
          this.mode = (!this.mode || this.mode === 'Home Delivery') && this.charge.length && !this.cartContainsOnlyDsc() ?
          'Next Day Delivery' : 'In Store Pickup';
          if (this.$rootScope.deliveryMode && !this.cartContainsOnlyDsc()) this.mode = this.$rootScope.deliveryMode;
        }
        else {
          this.notDeliverable = true;
          // this.toaster.pop('success', 'We do not deliver at this address');
        }
        this.promise1.resolve();
      }
    );*/
  }

  getTotalWeight() {
    return this.cartDetail.cartItems &&
      this.cartDetail.cartItems.map(item => item.item.weight * item.quantity)
        .reduce((prev, curr) => prev + curr, 0);
  }

  getSameDayCharge() {
    if (this.charge && this.calculateSameDay()) {
      return this.getTotalWeight() > 70 ? this.charge[0].sameDayChargeover70lbs : this.charge[0].sameDayCharge;
    }
    return null;
  }

  getNextDayCharge() {
    if (this.userShippingZone) {
      return this.userShippingZone.nextDayCharge;
    }
    return null;
  }
  getShippingDiscountCharge() {
    if(this.cartContainsOnlyGift()){
      return 0.00;
    } else if(this.cartContainsOnlyGiftAndDSC()) {
      return 0.00;
    }
    if (this.cartDetail) {
      if (this.cartDetail.freeshipping.zone && this.isShippingDiscountEligible() && this.mode !== this.inStoreDelivery) {
        return this.cartDetail.freeshipping.zone.nextDayCharge;
      }
    }
    return 0;
  }
  getSelectedShipmentCharge() {
    if(this.cartContainsOnlyGift()){
      return 0.00;
    } else if(this.cartContainsOnlyGiftAndDSC()) {
      return 0.00;
    }

    if (this.userShippingZone && this.mode !== this.inStoreDelivery) {
      return this.userShippingZone.nextDayCharge;
    }
    /*  if (this.mode === 'Same Day Delivery' && this.charge) {
      return this.getTotalWeight() > 70 ? this.charge[0].sameDayChargeover70lbs : this.charge[0].sameDayCharge;
    }
    else if (this.mode === 'Next Day Delivery' && this.charge) {
      return this.getTotalWeight() > 70 ? this.charge[0].nextDayChargeover70lbs : this.charge[0].nextDayCharge;
    }*/
    return 0;
  }

  // Retail price is the undiscounted price of items * quantity.
  retailPrice() {
    return this.cartDetail.cartItems &&
      this.cartDetail.cartItems.map(item => item.item.price * item.quantity)
        .reduce((prev, curr) => prev + curr, 0);
  }

  // DSC discount of 15% price on retail price
  // dscDiscount() {
  //   if (this.isDscMember() || this.cartContainsDsc()) {
  //     let dscItems = this.cartDetail.cartItems &&
  //     this.cartDetail.cartItems.filter(item => item.item.subCategory.category.dscCategory);
  //     let totalPrice = dscItems && dscItems.map(item => item.item.price * item.quantity)
  //       .reduce((prev, curr) => prev + curr, 0);
  //     return totalPrice * 15 / 100;
  //   }
  //   return 0;
  // }

  // Subtotal is retail price minus 15% dsc discount price.
  // subtotal() {
  //   return this.retailPrice() - this.dscDiscount();
  // }

  subtotal() {
    let totalPrice = 0;
    if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired &&
      this.discountCoupon.discountType === 'HIGHPERCENTAGE') {

      if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        var maxPrice = 0;
        var maxPriceId = 0;
        var isDscMember = this.isDscMember() || this.cartContainsDsc();
        angular.forEach(this.cartDetail.cartItems, function (item, key) {
          // console.log(key);
          if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
            maxPriceId = item.item.id;
            maxPrice = item.item.price;

          }
        });
        angular.forEach(this.cartDetail.cartItems, function (item, key) {
          // console.log(key);
          if (maxPriceId === item.item.id) {
            if (item.subCategory.category.dscCategory && isDscMember) {
              totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * (item.quantity - 1));
            }
            else {
              totalPrice = totalPrice + (item.item.price * (item.quantity - 1));
            }
            totalPrice = totalPrice + item.item.price;
          }
          else {
            if (item.subCategory.category.dscCategory && isDscMember) {
              totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity);
            }
            else {
              totalPrice = totalPrice + (item.item.price * item.quantity);
            }
          }
        });
      }
    }
    else {
      if (this.isDscMember() || this.cartContainsDsc()) {
        let dscItems = this.cartDetail.cartItems && this.cartDetail.cartItems.filter(item => item.subCategory.category.dscCategory);
        let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        let nondscItems = this.cartDetail.cartItems && this.cartDetail.cartItems.filter(item => !item.subCategory.category.dscCategory);
        let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity)
          .reduce((prev, curr) => prev + curr, 0);
        totalPrice = dscTotal + nonDscTotal;
      }
      else {
        totalPrice = this.retailPrice();
      }
    }
    return totalPrice;
  }

  taxableAmount() {
    let totalTaxablePrice = 0;
    var taxable = false;
    var ctrl=this;
    if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired &&
      this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        // console.log("Inside1--");
      if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        var maxPrice = 0;
        var maxPriceId = 0;

        var isDscMember = this.isDscMember() || this.cartContainsDsc();
        angular.forEach(ctrl.cartItemTaxDetails, function (item, key) {
          if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
            maxPriceId = item.item.id;
            maxPrice = item.item.price;
          }
        });
        angular.forEach(ctrl.cartItemTaxDetails, function (item, key) {
          taxable = ctrl.getCheckForShippingTaxable(item);
          if (maxPriceId === item.item.id) {
            if (item.subCategory.category.dscCategory && isDscMember && (taxable)) {
              totalTaxablePrice = totalTaxablePrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * (item.quantity - 1));
            }
            else if (taxable) {
              totalTaxablePrice = totalTaxablePrice + (item.item.price * (item.quantity - 1));
            }
            if (taxable) {
              totalTaxablePrice = totalTaxablePrice + item.item.price;
            }
          }
          else {
            if (item.subCategory.category.dscCategory && isDscMember && (taxable)) {
              totalTaxablePrice = totalTaxablePrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity);
            }
            else if (taxable) {
              totalTaxablePrice = totalTaxablePrice + (item.item.price * item.quantity);
            }
          }
        });

      }
    }
    else {
      if (this.isDscMember() || this.cartContainsDsc()) {
        let dscItems = this.cartItemTaxDetails && this.cartItemTaxDetails.filter(item => item.subCategory.category.dscCategory);
        let nondscItems = this.cartItemTaxDetails && this.cartItemTaxDetails.filter(item => !item.subCategory.category.dscCategory);
        let taxableDscItems = dscItems.filter(item => (item.item.taxable));
        let taxableNonDscItems = nondscItems.filter(item => (item.item.taxable));
        let taxableDscAmount = 0.00;
        let taxableNonDscAmount = 0.00;
        angular.forEach(this.cartItemTaxDetails, function (item, key) {
          taxable = ctrl.getCheckForShippingTaxable(item);
          if(taxable){
            if (item.subCategory.category.dscCategory) {
              totalTaxablePrice= totalTaxablePrice+ ((Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity);
            } else {
              totalTaxablePrice= totalTaxablePrice+ (item.item.price * item.quantity);
            }
          }
          });
      }
      else {
        let taxablePrice = 0.00;
        // let taxableItems = this.cartItemTaxDetails && this.cartItemTaxDetails.filter(item => (item.item.taxable));
        angular.forEach(this.cartItemTaxDetails, function (item, key) {
          taxable = ctrl.getCheckForShippingTaxable(item);
          if(taxable){
            taxablePrice= taxablePrice+ (item.item.price * item.quantity);
          }
          });
        totalTaxablePrice = taxablePrice;
      }
    }
    return totalTaxablePrice;
  }


  getTax() {
    // console.log("Tax Here",this.mode);
    
    console.log("Tax Here",this.mode);
    if (this.mode == '') {
      // this.$spinner.hide('appSpinner');
      return 0;
    }
    if(this.mode === this.nextDayDelivery && this.profile.store.validateAddressType !== 'NOT_VALIDATE' && 
    this.profile.store.validateAddressType != this.profile.validatedAddressType
    && !this.isAddressValidated){
      const userDetail = this.profile;
      console.log("this.profile : userDetail : ", this.profile);
      userDetail.shippingAddressLine1 = this.addressDetail.shippingAddressLine1;
      userDetail.shippingAddressLine2 = this.addressDetail.shippingAddressLine2;
      userDetail.shippingCity = this.addressDetail.shippingCity;
      userDetail.shippingZipCode = this.addressDetail.shippingZipCode;
      
      // this.avalaraResolveAddress(userDetail,this.profile.store, 1);
    this.$auth.avalaraResolveAddress(userDetail, this.profile.store)
      .then( resolveAddress => {
        console.log("ResolveAddress : ", resolveAddress);
        this.$auth.openPopUpForAddressResolve(userDetail,resolveAddress, 
          addResolved => {
            this.isAddressValidated=true;
            console.log("Call back function", addResolved);
            if(addResolved.isCanceled){
              console.log("Canceled");
              this.changeAddress();
            } else {
              this.setTempDeliveryAddress(addResolved);
              this.calculateTaxes();
            }
          });
    })
    .catch(err => {
      this.isAddressValidated=true;
      console.log("Error in edit : ", err);
      this.calculateTaxes();
      this.$auth.printCustomerGenericLogs(err);
    });
    } else {
      // this.avalaraResolveAddress(this.profile,this.profile.store, 1);
      this.calculateTaxes();
    }
  }


  calculateTaxUponBBandDiscount(taxableDiscountAmount,discountAmount){
    var bbdiscount = 0.00;

    if(this.cartContainsDsc() || this.cartContainsGiftCard()){      
      bbdiscount = (Math.round((this.taxableAmount() - taxableDiscountAmount) / (this.subtotal() - this.detuctTotalDscMemberAndGiftAmount() - discountAmount) * this.couponAmount * 100) / 100);
    } else {
      bbdiscount = (Math.round((this.taxableAmount() - taxableDiscountAmount) / (this.subtotal() - discountAmount) * this.couponAmount * 100) / 100);
    } 
    if(isNaN(bbdiscount)){
      bbdiscount=0.00;
    }
    var data = {
      'shipTo': {
        'name': this.addressDetail.customer.firstName + this.addressDetail.customer.lastName,
        'addressLine1': this.addressDetail.shippingAddressLine1,
        'addressLine2': this.addressDetail.shippingAddressLine2,
        'city': this.addressDetail.shippingCity,
        'state': this.addressDetail.shippingState,
        'country': this.addressDetail.shippingCountry,
        'zip': this.addressDetail.shippingZipCode,
        'addressType': 'Shipping',
        'deliveryType': this.mode,
        'expectedDeliveryTime': '',
        'estimatedDeliveryDateTime': '',
        'phoneNumber': this.addressDetail.phoneNumber
      },
      'totalAmount': this.subtotal() - this.couponAmount - this.discountCouponAmount,
      'taxableAmount': this.taxableAmount() - taxableDiscountAmount,
      // 'shippingCharge': this.getSelectedShipmentCharge() - this.getShippingDiscountCharge(),
      'shippingCharge': this.getSelectedShipmentCharge(),
      'shippingDiscount': this.getShippingDiscountCharge(),
      'discount': bbdiscount,
      'appliedBBCoupon': this.appliedBirdBuckCoupon,
      'discountCode': this.discountCode
    };
    this.isCallingAPI = true;
    this.$order.calculateTaxes(data)
      .then(success => {
        // console.log("success",success);
        // if (this.taxes.tax && this.taxes.tax.amountToCollect >= 0) {
        //   this.isCallingAPI = false;
        // }
        console.log("this.taxes :  : ", this.taxes);
        if (this.taxes!=null && this.taxes.amountToCollect >= 0) {
          this.isCallingAPI = false;
        }
      },
      error => {
        // console.log("Error on tax calc",error);
        this.toaster.pop('success', 'Error in tax calculation'); 
        this.$auth.printCustomerGenericLogs(error);
      })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      }
      );
  }

  getTotalTax() {
    if (this.taxes.amountToCollect && this.mode != '') {
      // return this.taxes.tax.amountToCollect;
      return this.taxes.amountToCollect;
    }
    return 0;
  }

  getDeliveryReceiptFee() {
    if (this.taxes.deliveryReceiptFee && this.mode != '') {
      // return this.taxes.tax.amountToCollect;
      return this.getTotalTax()-this.taxes.deliveryReceiptFee;
    }
    return 0;
  }

  getDSCPoints() {
    return this.subtotal() - this.couponAmount;
  }

  // totalPrice excludes shipping charge. getTotalAmount() includes shipping charge as well.
  totalPrice() {

    if (this.couponAmount == null) {

      this.couponAmount = 0;
    }

    if (this.discountCouponAmount == null) {

      this.discountCouponAmount = 0;
    }
    return this.subtotal() + this.getTotalTax() - this.couponAmount - this.discountCouponAmount;
  }

  shippingGrossPrice() {
    var totalGiftCardAmountPurchasing = 0.00;
    var $ctrl = this;
    angular.forEach(this.cartDetail.cartItems, function (item, key) {
      // console.log("this.isMiscelleneousCategory", $ctrl.isMiscelleneousCategory);
      if(item.item.masterProduct.category.id === $ctrl.isMiscelleneousCategory && 
        item.item.masterProduct.masterCode.charAt(0) === $ctrl.giftCardMasterCodeStartsWith){
          totalGiftCardAmountPurchasing = totalGiftCardAmountPurchasing + (item.item.price * item.quantity);
        }
      });

      if(this.profile.store.hasErply){
        return this.getSubtotal() - totalGiftCardAmountPurchasing;
      } else {
        return this.getSubtotal() - totalGiftCardAmountPurchasing - this.couponAmount - this.discountCouponAmount;
      }
    
  }

  // total amount is totalPrice + shipping price.
  isShippingDiscountEligible() {
    let grossPrice = this.shippingGrossPrice();
    var res = false;
    var result = false;
    if (!this.notDeliverable) {
      res = ((this.cartDetail.user.store.isFreeShipping) && (grossPrice >= this.cartDetail.freeshipping.thresholdValue));
      var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
      var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
      var currentDate = new Date();
      if (res) {
        if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
          result = true;
        }
      }
    }
    return result;
  }
  getTotalAmount() {

    if (this.mode === this.inStoreDelivery || this.mode === '') {
      return this.totalPrice();
    }
    if (this.notDeliverable) {
      return this.totalPrice();
    }
    if (this.isShippingDiscountEligible()) {
      return +(this.getSelectedShipmentCharge() + this.totalPrice() - this.getShippingDiscountCharge()).toFixed(2);
    }
    else {
      return +(this.getSelectedShipmentCharge() + this.totalPrice()).toFixed(2);
    }
  }

  getDiscountedSubTotalAmount() {

    if (this.mode === this.inStoreDelivery) {
      return this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount;
    }
    if (this.notDeliverable) {
      return this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount;
    }
    if (this.isShippingDiscountEligible()) {
      return +(this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount -
        this.getSelectedShipmentCharge() + this.getShippingDiscountCharge()).toFixed(2);

    }
    else {
      return +(this.totalPrice() - this.getTotalTax() + this.discountCouponAmount + this.couponAmount
        + this.getSelectedShipmentCharge()).toFixed(2);
    }
  }

  cartContainsGiftCard() {
    return this.cartDetail.cartItems
      ? this.cartDetail.cartItems.filter(item => {
        var masterCode = item.item.masterProduct.masterCode;
        var seriesNumber = masterCode.charAt(0);
        var categoryId = item.item.masterProduct.category.id;
        return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
      }).length
      : false;
  }

  cartContainsDsc() {
    return this.cartDetail.cartItems
      ? this.cartDetail.cartItems.filter(item => {
        return item.item.masterProduct.masterCode === this.dscMasterCode;
      }).length
      : false;
  }


  // cartContainsOnlyDsc() {
  //   // console.log(this.cartContainsGiftCard());
  //   const totalItemsInCart = this.cartDetail.cartItems.length;
  //   if (
  //     this.cartContainsDsc() && (totalItemsInCart === this.cartContainsDsc())
  //     ||
  //     this.cartContainsGiftCard() && (totalItemsInCart === this.cartContainsGiftCard())
  //     ||
  //     (this.cartContainsGiftCard() && this.cartContainsDsc() && (totalItemsInCart === 2))) {
  //     this.mode = this.inStoreDelivery;
  //     this.resetDeliveryMode(this.mode);
  //     return true;
  //   } else {
  //     if (this.$rootScope.tempdeliveryMode) {
  //       this.mode = this.$rootScope.tempdeliveryMode;
  //     } else {
  //       this.mode = "";
  //     }
  //     return false;
  //   }
  // }

  cartContainsOnlyDsc() {
    // console.log(this.cartContainsGiftCard());
    const totalItemsInCart = this.cartDetail.cartItems.length;
    if (this.cartContainsDsc() && (totalItemsInCart === this.cartContainsDsc())) {
      this.mode = this.inStoreDelivery;
      this.resetDeliveryMode(this.mode);
      // console.log("If This mode is :", this.mode);
      return true;
    } else {
      if (this.$rootScope.tempdeliveryMode) {
        this.mode = this.$rootScope.tempdeliveryMode;
      } else {
        this.mode = "";
      }
      // console.log("Else This mode is :", this.mode);
      return false;
    }
  }

  cartContainsOnlyGift() {
    const totalItemsInCart = this.cartDetail.cartItems.length;
    return this.cartContainsGiftCard() && (totalItemsInCart === this.cartContainsGiftCard());
  }
  
  cartContainsOnlyGiftAndDSC() {
    const totalItemsInCart = this.cartDetail.cartItems.length;
    let noOfItems = this.cartDetail.cartItems
      ? this.cartDetail.cartItems.filter(item => {
        var masterCode = item.item.masterProduct.masterCode;
        var seriesNumber = masterCode.charAt(0);
        var categoryId = item.item.masterProduct.category.id;
        return (seriesNumber === '9' && categoryId === this.isMiscelleneousCategory)
        || (item.item.masterProduct.masterCode === this.dscMasterCode);
      }).length
      : false;
    return totalItemsInCart===noOfItems;
  }

  // converts date to UTC date
  convertDatetoUTC(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(),
      date.getUTCMinutes(), date.getUTCSeconds());
  }

  // Function assumes that the timezone is sent in format "+-HH:MM"
  convertTimezoneToMilliseconds(timezone) {
    let arr = timezone.split(':');
    let signAndHours = arr[0];
    let minutes = +arr[1];
    let sign = signAndHours.charAt(0);
    let hours = +signAndHours.substr(1);
    let milliseconds = ((hours * 60) + minutes) * 60000;
    let result = (sign === '+') ? +milliseconds : -milliseconds;
    return result;
  }

  // creates date object in Store's timezone. Does not inc daytime saving, Use for current time only.
  // See momentJs library for daytime features etc. not implementing as we do not require it here.
  getStoreDate() {
    let systemDate = new Date();
    let UTCDate = this.convertDatetoUTC(systemDate);
    let timezoneInMilliseconds = this.store.timeZone && this.convertTimezoneToMilliseconds(this.store.timeZone);
    let storeDateInMilliseconds = UTCDate.getTime() + timezoneInMilliseconds;
    let storeDate = new Date(storeDateInMilliseconds);
    return storeDate;
  }

  // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
  changeStringtoDateObject(stringTime) {
    let timeArray = stringTime.split(':');
    let hours = timeArray[0];
    let minutes = timeArray[1];
    let timeObject = this.getStoreDate();
    timeObject.setMinutes(minutes);
    return timeObject.setHours(hours);
  }

  formattedTime(dateTime) {
    const date = dateTime ? new Date(dateTime) : this.getStoreDate();
    const hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
    let time = (hours < 10 ? `0${hours}` : hours) + ':' +
      (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes());
    const ampm = date.getHours() >= 12 ? ' PM' : ' AM';
    return time + ampm;
  }

  getStoreTiming(date) {
    const forDate = date || this.getStoreDate();
    const mapping = {
      '0': 'Sunday',
      '1': 'Monday',
      '2': 'Tuesday',
      '3': 'Wednesday',
      '4': 'Thursday',
      '5': 'Friday',
      '6': 'Saturday'
    };
    const day = mapping[forDate.getDay()];
    return this.store.storeTimings && this.store.storeTimings.filter(el => el.day === day)[0];
  }

  storeOpeningTime(forDate) {
    if (this.store.storeTimings) {
      let today = forDate || this.getStoreDate();
      const open = this.getStoreTiming(forDate).openTime;
      const hours = open.split(':')[0];
      const minutes = open.split(':')[1];
      today.setHours(hours);
      today.setMinutes(minutes);
      return today;
    }
  }

  storeClosingTime(forDate) {
    if (this.store.storeTimings) {
      let today = forDate || this.getStoreDate();
      const close = this.getStoreTiming(forDate).closeTime;
      const hours = close.split(':')[0];
      const minutes = close.split(':')[1];
      today.setHours(hours);
      today.setMinutes(minutes);
      return today;
    }
  }

  getNextWorkingDay() {   
    const mapping = {
      'sunday': '0',
      'monday': '1',
      'tuesday': '2',
      'wednesday': '3',
      'thursday': '4',
      'friday': '5',
      'saturday': '6'
    };
    const forDate = this.getStoreDate();
    const workingDays = this.store.storeTimings.filter(el => !el.isHoliday);
    let nextWorkingDay;
    for (let i = 0; i < workingDays.length; i++) {
      if (forDate.getDay() < mapping[workingDays[i].day.toLowerCase()]) {
        nextWorkingDay = workingDays[i];
        break;
      }
    }
    nextWorkingDay = nextWorkingDay || workingDays[0];
    if (nextWorkingDay && mapping[nextWorkingDay.day.toLowerCase()] == forDate.getDay()) {
      nextWorkingDay.isSameDay = true;
    }
    return nextWorkingDay;
  }

  calculateInStorePick() {
    if (this.store.storeTimings) {
      let orderPlacing = this.getStoreDate();
      // this.store.inStorePickupTime is assumed to be coming in minutes e.g. 120
      let pickupTime = this.storeClosingTime().setMinutes(
        this.storeClosingTime().getMinutes() - parseInt(this.store.inStorePickupTime)
      );
      // console.log("orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime))",orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime)));
      if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime)) < pickupTime &&
        !this.getStoreTiming().isHoliday) {
        let origOrderPlacing = this.getStoreDate();
        // If Order is placed before opening of Store
        if (origOrderPlacing < this.storeOpeningTime()) {
          let opening = this.storeOpeningTime();
          const finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime)));
          this.estimatedDeliveryDateTime = opening;
          return finalTime;
        }
        this.estimatedDeliveryDateTime = orderPlacing;
        return 'Today, ' + this.formattedTime(orderPlacing);
      }
      else {
        return this.calculateNextDay();
      }
    }
  }

  calculateSameDay() {
    if (this.store.storeTimings) {
      let orderPlacing = this.getStoreDate();
      let lastDeliveryTime = this.changeStringtoDateObject(this.store.deliveryPickupTime);
      if (orderPlacing.setMinutes(orderPlacing.getMinutes() + parseInt(this.store.fullFillTime)) < lastDeliveryTime &&
        // let deliveryBoy = this.storeClosingTime().setMinutes(this.storeClosingTime().getMinutes() - this.store.deliveryPickupTime);
        // if (orderPlacing.setMinutes(orderPlacing.getMinutes() + this.store.fullFillTime) < deliveryBoy &&
        !this.getStoreTiming().isHoliday) {
        let origOrderPlacing = this.getStoreDate();
        // If Order is placed before opening of Store
        if (origOrderPlacing < this.storeOpeningTime()) {
          let opening = this.storeOpeningTime();
          const finalTime = 'Today, ' + this.formattedTime(opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime)));
          this.estimatedDeliveryDateTime = opening;
          return finalTime;
        }
        this.estimatedDeliveryDateTime = orderPlacing;
        return 'Today, ' + this.formattedTime(orderPlacing);
      }
      return null;
    }
  }

  calculateNextDay() {
    if (this.store.storeTimings) {
      let date;
      let nextDate;
      let opening;
      for (var z=1; z<=7; z++) {
          date = this.getStoreDate();
          nextDate = new Date(date.setDate(date.getDate() + z));
          if (!this.getStoreTiming(nextDate).isHoliday) {
            opening = this.storeOpeningTime(nextDate);
            // opening.setDate(opening.getDate() + 1);
            opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime));
            this.estimatedDeliveryDateTime = opening;
            if(z==7){
              return `next ${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
            }
            return `${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
          }
        if(z==7){
          this.noTimeForOrderReadyBy = true;
          break;
        } 
      }
      // else {
      //   let d = this.getStoreDate();
      //   const nextWorkingDate = d.setDate(d.getDate() + (this.getNextWorkingDay().id + 6 - d.getDay()) % 7);
      //   let opening = this.storeOpeningTime(new Date(nextWorkingDate));
      //   opening.setMinutes(opening.getMinutes() + parseInt(this.store.fullFillTime));
      //   this.estimatedDeliveryDateTime = opening;
      //   if (this.getNextWorkingDay().isSameDay) {
      //     return `next ${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
      //   } else {
      //     return `${this.getNextWorkingDay().day}, ${this.formattedTime(opening)}`;
      //   }        
      // }
    }
  }

  

  dateToString(dateobj) {
    if(dateobj!=null)
    {
      let yr = dateobj.getFullYear();
      let month = dateobj.getMonth() + 1;
      let date = dateobj.getDate();
      let hr = dateobj.getHours();
      let min = dateobj.getMinutes();
      let sec = dateobj.getSeconds();
      return '' + yr + '-' + month + '-' + date + ' ' + hr + ':' + min + ':' + sec;
    } else {
      return '';
    }
   
  }

  submit() {   
    
    if (this.filteredInstoreItem && this.filteredDropShipItem) {
      this.toaster.pop('success', 'Please modify your cart!');
      return false;
    }

    // Validating PO Box character in address
    if((this.mode === this.nextDayDelivery) && this.$auth.validatingPoBoxAddress(this.profile.store.postboxAddress,this.addressDetail.shippingAddressLine1))
    {
      // this.toaster.pop('success', 'We do not deliver to PO Boxes. Please enter a street address.');
      return false;
    }

    // Validation for curbside detail collection popup
    if (this.isCurbside) {
      if (!this.curbSideDetails) {
        this.getCurbsideDetails(true);
        return false;
      }
    }

    let expectedDeliveryTime;
    if (this.mode === this.inStoreDelivery) {
      expectedDeliveryTime = this.calculateInStorePick();
    }
    else if (this.mode === 'Same Day Delivery') {
      expectedDeliveryTime = this.calculateSameDay();
    }
    else {
      expectedDeliveryTime = this.calculateNextDay();
    }
    var data = {
      "couponIdentifiers" : []
    };
    this.appliedBirdBuckCoupon = "";
    if(!this.profile.store.hasErply){
      this.appliedBirdBuckCoupon =  this.couponNumber;
    } else {
      var bbApplied = "";
     for(var i=0; i<this.example1model.length; i++) {
        if(this.example1model[i]!=null && this.example1model[i].label!=null) {
          bbApplied = bbApplied + this.example1model[i].label;
          if(i<this.example1model.length-1){
            bbApplied = bbApplied + ",";
          }
        }
       }
      this.appliedBirdBuckCoupon = bbApplied;
    }

    // console.log('expectedDeliveryTime', expectedDeliveryTime);
    //  console.log('this.estimatedDeliveryDateTime', this.estimatedDeliveryDateTime);
    let dateStr = this.dateToString(this.estimatedDeliveryDateTime);
    // console.log('dateStr', dateStr);
    let deliveryDetail = {
      'shipTo': {
        'name': this.addressDetail.firstName + " " + this.addressDetail.lastName,
        'addressLine1': this.addressDetail.shippingAddressLine1,
        'addressLine2': this.addressDetail.shippingAddressLine2,
        'city': this.addressDetail.shippingCity,
        'state': this.addressDetail.shippingState,
        'country': this.addressDetail.shippingCountry,
        'zip': this.addressDetail.shippingZipCode,
        'addressType': 'Shipping',
        'deliveryType': this.mode,
        'expectedDeliveryTime': dateStr,
        'estimatedDeliveryDateTime': this.estimatedDeliveryDateTime,
        'phoneNumber': this.addressDetail.phoneNumber,
        'isCurbside': this.isCurbside,
        'curbSideDetails': JSON.stringify(this.curbSideDetails)
      },
      'appliedBBCoupon': this.appliedBirdBuckCoupon,
      'discountCode': this.discountCode,
      'shippingCharge':+this.getSelectedShipmentCharge()?(this.getSelectedShipmentCharge()).toFixed(2)||0:0,
      'shippingDiscount': +this.getShippingDiscountCharge()? this.getShippingDiscountCharge().toFixed(2) : 0,
      // 'shippingCharge': +(this.getSelectedShipmentCharge()).toFixed(2) || 0,
      // 'shippingDiscount': +this.getShippingDiscountCharge().toFixed(2),
      'totalPrice': +parseFloat(this.totalPrice()).toFixed(2),
      'orderNotes': this.orderNotes,
      'manualPromotionIDs' : this.discountCouponCode,
      'isGiftOrder' : this.isGiftOrder
    };
    if (this.isDscMember() || this.cartContainsDsc()) {
      // deliveryDetail.dscPoints = this.subtotal();
      deliveryDetail.dscPoints = this.getClubPoints();
      // console.log("Delivery Pg : "+ deliveryDetail.dscPoints);
    }
    this.isCallingAPI = true;
    this.$order.orderCheckout(deliveryDetail)
      .then(
      success => {
        // if (this.cardInfo.length) {
        this.isCallingAPI = false;
        this.$state.go('card-detail', { orderId: success.data.additionalInfo });
        // }
        /* else {
           let device = this.getDeviceParameter();
           this.$order.initializePayment(success.data.additionalInfo, device)
             .then(
               success => {
                 if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
                   this.toaster.pop('success', 'Unable to process your payment currently. Please try again later.');
                   this.isCallingAPI = false;
                   return;
                 }
                 this.goToMerchantPage(success.data);
               },
               err => {
                 this.toaster.pop('success', err.data.message);
                 this.isCallingAPI = false;
               }
             );
         }*/
      },
      error => {
        this.isCallingAPI = false;
        if (error.data.errorCode === 640) {
          this.toaster.pop('success', 'Please select Delivery Option.');
          return;
        }
        if (error.data.errorCode === 645) {
          this.toaster.pop('success', error.data.message);
          return;
        }
        if (error.data.errorCode === 665 || error.data.errorCode === 671) {
          this.$state.go('cart');
          return;
        }
        if (error.data.errorCode === 659) {
          this.billingError = error.data.message;
          var $ctrl = this;
          this.$uibModal.open({
            size: 'sm',
            template: '<div class="modal-body" id="modal-body">' +
              '<h5 class="font-weight-bold">{{billingError}}</h5>' +
              '</div>' +
              '<div class="modal-footer">' +
              '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
              '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' +
              '</div>',
            controller: ['$scope', 'orderService', '$uibModalInstance', '$state',
              function ($scope, $order, $uibModalInstance, $state) {
                $scope.billingError = $ctrl.billingError;
                $scope.ok = () => {
                  $uibModalInstance.close();
                  $state.go('profile.edit');
                };
                $scope.cancel = () => $uibModalInstance.dismiss('cancel');
              }
            ]
          });
          return;
        } else {
          this.$uibModal.open({
            size: 'sm',
            template: '<div class="modal-body" id="modal-body">' +
              `<h5 class="font-weight-bold">We can't process your order at this time. Please call the store.</h5>` +
              '</div>' +
              '<div class="modal-footer">' +
              '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">OK</button>' +
              '</div>',
            controller: ['$scope', 'orderService', '$uibModalInstance',
              function ($scope, $order, $uibModalInstance) {
                $scope.ok = () => {
                  $uibModalInstance.close();
                  location.reload();
                };
                $scope.cancel = () => $uibModalInstance.dismiss('cancel');
              }
            ]
          });
        }
        /*
        this.$uibModal.open({
          size: 'sm',
          template: '<div class="modal-body" id="modal-body">' +
            '<h5 class="font-weight-bold">Price has been updated for this order. Confirm to reload your Cart details.</h5>' +
            '</div>' +
            '<div class="modal-footer">' +
            '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
            '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' +
            '</div>',
          controller: ['$scope', 'orderService', '$uibModalInstance',
            function ($scope, $order, $uibModalInstance) {
              $scope.ok = () => {
                $uibModalInstance.close();
                location.reload();
              };
              $scope.cancel = () => $uibModalInstance.dismiss('cancel');
            }
          ]
        });
        */
      }
      ).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  goToMerchantPage(data, method) {
    method = method || 'post';

    let form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', data.message);

    let payIdField = document.createElement('input');
    payIdField.setAttribute('type', 'hidden');
    payIdField.setAttribute('name', 'PaymentID');
    payIdField.setAttribute('value', data.additionalInfo);
    form.appendChild(payIdField);

    let returnMethodField = document.createElement('input');
    returnMethodField.setAttribute('type', 'hidden');
    returnMethodField.setAttribute('name', 'ReturnMethod');
    returnMethodField.setAttribute('value', 'POST');
    form.appendChild(returnMethodField);

    document.body.appendChild(form);
    form.submit();
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  getDeviceParameter() {
    if (window.innerWidth <= 576) {
      return 'm';
    }
    else if (window.innerWidth > 576 && window.innerWidth <= 768) {
      return 't';
    }
    else if (window.innerWidth > 768) {
      return 'd';
    }
  }
  checkGiftCard(form, giftCard) {
    // console.log(this.giftCards);
    this.giftCards.push(giftCard);
  }

  checkDiscountCoupon(form, coupon, isApply) {
    // var highPrice=0;appliedDiscountCoupon
    // console.log(this.cartDetail.cartItems);
    // this.removeFreeItems();
    if (form.$invalid) {
      this.discountCouponNumber = null;
      this.discountCouponAmount = 0;
      this.taxableDiscountAmount = 0;
      this.isDiscountCouponValid = false;
      this.discountCouponStatus = 'Invalid Code';
      this.discountCoupon.couponCode = null;
      this.appliedDiscountCoupon = null;
      this.callingTax(1,isApply);
      // this.getTax();
      return;
    }
    form.error = {};
    var shipToStateId;
    var isInStorePickUp = true;
    if(this.mode!==''){
      isInStorePickUp = this.mode===this.inStoreDelivery?true:false;
      shipToStateId = this.getShipToStateId(isInStorePickUp);
    } else {
      shipToStateId = this.getShipToStateId(true);
    }
    
    let discountPromise = this.$order.getCouponDiscount(coupon,isInStorePickUp,shipToStateId)
      .then(success => {
        if(!this.profile.store.hasErply){
          if(this.discountCoupon && (this.discountCoupon.discountType === 'FREEITEM' || this.discountCoupon.discountType === 'BUYXGETY')){
            this.$order.getCartDetail(false).then(() => {
              this.getUserProfile();
            })
            .catch(err => {
              this.$auth.printCustomerGenericLogs(err);
            });
          }
        }
        this.appliedDiscountCoupon = this.discountCoupon.couponCode;
        this.isValidToApplyPromo = true;
        this.discountCode = this.discountCoupon.couponCode;
        this.isDiscountTotalNegative = false;
        this.isDiscountCouponValid = true;
        this.discountCouponDiscountType = this.discountCoupon.discountType;

        this.discountCouponAmount = this.getDiscountValue(this.discountCoupon, 'discount');
        this.discountCouponAmount = Math.round(100 * this.discountCouponAmount) / 100;
        this.isDiscountCouponExpired = this.discountCoupon.expired;
        this.isDiscountCouponEnabled = this.discountCoupon.enabled;
        // console.log(this.discountCoupon);
        // console.log(this.subtotal());
        this.discountCouponID = this.discountCoupon.id;
        // console.log("BB----");
        // console.log(this.couponAmount);
        // console.log("DC");
        // console.log(this.discountCouponAmount);
        if (this.discountCoupon.message) {
          this.cError = true;
          this.discountCouponStatus = this.discountCoupon.message;
          this.discountCouponID = null;
          this.discountCoupon.discountCouponCode = null;
          this.discountCouponAmount = 0;
          this.taxableDiscountAmount = 0;
          // this.discountCouponCode=null;
          this.discountCode = null;
          this.appliedDiscountCoupon = null;
          return 1;
        }
        if (this.couponAmount + this.discountCouponAmount >= this.subtotal()) {

          this.isDiscountTotalNegative = true;
          this.discountCouponID = null;
          this.discountCouponAmount = 0;
          this.discountCouponCode = null;
          this.discountCode = null;
          this.discountCoupon.couponCode = null;
          this.appliedDiscountCoupon = null;

        }
        if (this.getDSCItemFromCart()) {
          if (this.couponAmount + this.discountCouponAmount >= this.subtotal() - this.getDSCItemFromCart().price) {

            this.isValidToApplyPromo = false;
            this.discountCouponID = null;
            this.discountCouponAmount = 0;
            // this.discountCouponCode=null;
            this.discountCode = null;
            this.discountCoupon.couponCode = null;
            this.appliedDiscountCoupon = null;
          }

          let cartItemCount = this.cartDetail.cartItems.length;
          if (cartItemCount - 1 === this.getTotalGiftCardsCountFromCart()) {
            this.isValidToApplyPromo = false;
            this.discountCouponID = null;
            this.discountCouponAmount = 0;
            // this.discountCouponCode=null;
            this.discountCode = null;
            this.discountCoupon.couponCode = null;
            this.appliedDiscountCoupon = null;
          }
        }

        if (this.getTotalGiftCardsCountFromCart()) {
          let cartItemCount = this.cartDetail.cartItems.length;
          if (cartItemCount === this.getTotalGiftCardsCountFromCart()) {
            this.isValidToApplyPromo = false;
            this.discountCouponID = null;
            this.discountCouponAmount = 0;
            // this.discountCouponCode=null;
            this.discountCode = null;
            this.discountCoupon.couponCode = null;
            this.appliedDiscountCoupon = null;
          }
        }

        if (this.isDiscountCouponExpired || !this.isDiscountCouponEnabled) {

          this.discountCouponID = null;
          this.discountCouponAmount = 0;
          // this.discountCouponCode=null;
          this.discountCode = null;
          this.discountCoupon.couponCode = null;
          this.appliedDiscountCoupon = null;

        }
        // this.getTax();

        // Remove discountCoupon from cookies if promo code not valid to apply
        if (!this.isValidToApplyPromo || !this.discountCode || !this.discountCoupon.couponCode || this.isDiscountTotalNegative) {
          this.discountCouponAmount = 0;
          this.discountCode = null;
          this.removePromoCookies();
        }
        this.generateDiscountValidityMsg();
      })
      .catch(err => {

        this.discountCoupon = null;
        this.isDiscountCouponValid = false;
        this.discountCouponID = null;
        this.discountCouponAmount = 0;
        this.appliedDiscountCoupon = null;
        this.discountCouponCode = null;
        this.mobileDiscountCoupon = null;
        this.taxableDiscountAmount = 0;
        this.discountCode = null;
        this.removePromoCookies();
        // this.getTax();
        this.generateDiscountValidityMsg();

        this.cError = true;
        this.discountCouponStatus = err.data.message;
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        // this.getTax();
        this.callingTax(1,isApply);
        
      });
  }

  getShipToStateId(isInStorePickUp){

    if(isInStorePickUp){
      return this.store.storeId;
    } else {
      return  this.addressDetail && this.addressDetail.shippingState ? this.addressDetail.shippingState.id : null;
    }
  }

  checkBirdbuck(form, coupon, isApply) {
    if (form.$invalid || angular.isUndefined(coupon)) {
      this.couponNumber = null;
      this.couponAmount = 0;
      this.isCouponValid = false;
      this.couponStatus = 'Invalid Code';
      this.appliedBirdBuckCoupon = null;
      this.callingTax(1,isApply);
      // this.getTax();
      return;
    }
    form.error = {};
    this.$order.getBirdBuckCoupon(coupon)
      .then(() => {
        this.isTotalNegative = false;
        this.isBBAndSubtotalValid = true;
        this.isCouponValid = true;
        this.couponNumber = this.coupon.bbCouponNumber;
        this.couponAmount = this.coupon.bbCouponAmount;
        this.appliedBirdBuckCoupon = this.couponNumber;

        if (this.couponAmount >= this.subtotal()) {
          this.isTotalNegative = true;
          this.couponNumber = null;
          this.couponAmount = 0;
        }
        if (this.getDSCItemFromCart()) {
          if (this.couponAmount >= this.subtotal() - this.discountCouponAmount - this.getDSCItemFromCart().price) {
            this.isTotalNegative = true;
            this.isBBAndSubtotalValid = false;
            this.couponNumber = null;

            this.couponAmount = 0;
          }
          let cartItemCount = this.cartDetail.cartItems.length;
          if (cartItemCount - 1 === this.getTotalGiftCardsCountFromCart()) {
            this.isTotalNegative = true;
            this.isBBAndSubtotalValid = false;
            this.couponNumber = null;

            this.couponAmount = 0;
          }
        }

        if (this.getGiftCardItemFromCart()) {
          let cartItemCount = this.cartDetail.cartItems.length;
          if (cartItemCount === this.getTotalGiftCardsCountFromCart()) {
            this.isTotalNegative = true;
            this.isBBAndSubtotalValid = false;
            this.couponNumber = null;
            this.couponAmount = 0;
          }
        }
        // this.getTax();
        if (!this.isBBAndSubtotalValid || this.isTotalNegative || !this.isCouponValid) {
          this.couponAmount = 0;
          this.removeBBCookies();
        }
        this.generateValidityMsg();
      })
      .catch(err => {
        this.appliedBirdBuckCoupon = null;
        this.isCouponValid = false;
        this.couponNumber = null;
        this.couponAmount = 0;
        this.removeBBCookies();
        // this.getTax();
        this.generateValidityMsg();
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        // this.getTax();
        this.callingTax(1,isApply);
      });
  }

  resetDeliveryMode(mode) {
    this.$rootScope.tempdeliveryMode = mode;
    // Validating PO Box character in address
    if((mode === this.nextDayDelivery) && this.addressDetail.shippingAddressLine1 && this.$auth.validatingPoBoxAddress(this.profile.store.postboxAddress,this.addressDetail.shippingAddressLine1))
    {
      // this.toaster.pop('success', 'We do not deliver to PO Boxes. Please enter a street address.');
      return false;
    }
  }
  resetCouponValues() {
    /* this.couponNumber = null;
    this.couponAmount = 0;
    this.mobileCouponNumber = null;
    this.desktopCouponNumber = null;
    this.generateValidityMsg(true);
    this.discountCode = null;
    this.discountCouponAmount=0;
    this.taxableDiscountAmount = 0;
    this.discountCouponCode=null;
    this.mobileDiscountCoupon=null;
    this.generateDiscountValidityMsg(true); */
  }
  resetBBCouponValues() {
    this.couponNumber = null;
    this.couponAmount = 0;
    this.mobileCouponNumber = null;
    this.desktopCouponNumber = null;
    this.generateValidityMsg(true);

  }

  resetCouponForm(form) {
    form.$setUntouched();
    form.$setPristine();
    this.couponNumber = null;
    this.couponAmount = 0;
    this.isCouponValid = false;
    this.mobileCouponNumber = null;
    this.desktopCouponNumber = null;
  }

  generateValidityMsg(status) {
    this.couponStatus = null;
    if (status) return;
    if (this.isCouponValid === true && !this.isTotalNegative) {
      this.couponStatus = 'Successfully Applied';
    }
    else if (this.isCouponValid === false) {
      this.couponStatus = 'Invalid Code';
    }
    else if (this.isTotalNegative && this.isCouponValid && this.isBBAndSubtotalValid) {
      this.couponStatus = 'Your Subtotal Amount should be more than the Bird Buck Code amount';
    }
    else if (this.isTotalNegative && this.isCouponValid && !this.isBBAndSubtotalValid) {
      this.couponStatus = "Bird Bucks cannot be used to purchase a DSC membership or Gift cards.  Please add more product to use a Bird Buck.";
    }
    else {
      this.couponStatus = null;
    }
    return this.couponStatus;
  }

  getDiscountValue(discountInfo, type) {

    var ctrl=this;
    if (type === 'discount') {
      return discountInfo.couponAmount;
    }
    if (type === 'taxableDiscount') {
      return discountInfo.discountTaxable;
    }
    var taxable = false;
    this.discountPercentage = discountInfo.discountPercentage;
    this.discountAmount = discountInfo.discountAmount;
    this.dscDiscountPercentage = discountInfo.dscDiscountPercentage;
    this.nonDscDiscountPercentage = discountInfo.nonDscDiscountPercentage;
    this.nonTaxableAmount = this.subtotal() - this.taxableAmount();
    this.discountInfo = discountInfo;
    this.taxableDiscountAmount = 0;
    switch (discountInfo.discountType) {
      case 'AMOUNT':
        this.taxableDiscount = (this.taxableAmount() / this.subtotal()) * this.discountAmount;
        this.nonTaxableDiscount = (this.nonTaxableAmount / this.subtotal()) * this.discountAmount;
        this.discountValue = this.taxableDiscount + this.nonTaxableDiscount;
        // console.log('-----------SubTotal Amount -----------'+this.subtotal());
        // console.log('-----------Taxable Amount -----------'+this.taxableAmount());
        // console.log('-----------Non Taxable Amount -----------'+this.nonTaxableAmount);
        // console.log('-----------Taxable Discount Amount -----------'+this.taxableDiscount);
        // console.log('-----------Non Taxable Discount Amount -----------'+this.nonTaxableDiscount);

        // console.log('-----------App Calculated Discount Amount -----------'+discountInfo.couponAmount);
        // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
        if (type === 'discount') {
          return discountInfo.couponAmount;
        }
        if (type === 'taxableDiscount') {
          return this.taxableDiscount;
        }
        break;

      case 'FREEITEM':
        this.taxableDiscount = (this.taxableAmount() / this.subtotal()) * this.discountAmount;
        this.nonTaxableDiscount = (this.nonTaxableAmount / this.subtotal()) * this.discountAmount;
        this.discountValue = this.taxableDiscount + this.nonTaxableDiscount;
        if (type === 'discount') {
          return discountInfo.couponAmount;
        }
        if (type === 'taxableDiscount') {
          return this.taxableDiscount;
        }
        break;

      case 'BUYXGETY':
        this.taxableDiscount = (this.taxableAmount() / this.subtotal()) * this.discountAmount;
        this.nonTaxableDiscount = (this.nonTaxableAmount / this.subtotal()) * this.discountAmount;
        this.discountValue = this.taxableDiscount + this.nonTaxableDiscount;
        if (type === 'discount') {
          return discountInfo.couponAmount;
        }
        if (type === 'taxableDiscount') {
          return this.taxableDiscount;
        }
        break;

      case 'PERCENTAGE':
        var discountValue = 0;
        var taxableDiscountAmount = this.taxableDiscountAmount;
        var discountPercentage = this.discountPercentage;
        
        angular.forEach(this.cartItemTaxDetails, function (value) {
          taxable = ctrl.getCheckForShippingTaxable(value);
          discountValue = discountValue + (value.itemPrice * value.quantity * discountPercentage) / 100;
          // console.log(value.item.id+'------ '+value.itemPrice*value.quantity+'$ ------- '+value.item.taxable);
          if (taxable) {
            taxableDiscountAmount = taxableDiscountAmount + (value.itemPrice * value.quantity * discountPercentage) / 100;
          }
        });
        // console.log('-----------App Calculated Discount Amount -----------'+discountValue);
        // console.log('-----------App Calculated Taxble Discount Amount -----------'+taxableDiscountAmount);
        // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
        if (type === 'discount') {
          return discountValue;
        }
        if (type === 'taxableDiscount') {
          return taxableDiscountAmount;
        }
        break;
      case 'HIGHPERCENTAGE': // console.log(this.cartDetail);

        var maxItemPrice = 0;
        taxableDiscountAmount = this.taxableDiscountAmount;
        discountPercentage = this.discountPercentage;
        angular.forEach(this.cartItemTaxDetails, function (value) {
          if (value.itemPrice > maxItemPrice) {
            taxable = ctrl.getCheckForShippingTaxable(value);
            maxItemPrice = value.itemPrice;
            if (taxable) {
              taxableDiscountAmount = (value.itemPrice * discountPercentage) / 100;
            }
          }
        });
        this.discountValue = (maxItemPrice * discountPercentage) / 100;

        // console.log('-----------App Calculated Discount Amount -----------'+this.discountValue);
        // console.log('-----------App Calculated Taxable  Discount Amount -----------'+this.taxableDiscountAmount);
        // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
        if (type === 'discount') {
          return this.discountValue;
        }
        if (type === 'taxableDiscount') {
          return taxableDiscountAmount;
        }
        break;
      case 'SUBCATEGORY': // console.log('4');
        // console.log(this.cartDetail);
        // console.log(this.discountCoupon);
        // console.log(this.profile);
        var profile = this.profile;
        var currentDate = new Date();
        var discountCoupon = this.discountCoupon;
        var dscDiscountPercentage = this.dscDiscountPercentage;
        var nonDscDiscountPercentage = this.nonDscDiscountPercentage;
        discountValue = 0;
        taxableDiscountAmount = this.taxableDiscountAmount;
        angular.forEach(this.cartItemTaxDetails, function (value) {
          taxable = ctrl.getCheckForShippingTaxable(value);
          angular.forEach(discountCoupon.subCategories, function (value1) {

            if (value.subCategory.id === value1.id) {
              if (value.dscDiscountAmount && profile.customer.dscId) {
                if (value.dscDiscountAmount > 0 && profile.customer.dscId === 'C' && profile.customer.dscExpireDate >= currentDate) {
                  discountValue = discountValue + (value.itemPrice * value.quantity * dscDiscountPercentage) / 100;
                  if (taxable) {
                    taxableDiscountAmount = taxableDiscountAmount + (value.itemPrice * value.quantity * dscDiscountPercentage) / 100;
                  }
                }
                else {
                  discountValue = discountValue + (value.itemPrice * value.quantity * nonDscDiscountPercentage) / 100;
                  if (taxable) {
                    taxableDiscountAmount = taxableDiscountAmount + (value.itemPrice * value.quantity * nonDscDiscountPercentage) / 100;
                  }
                }
              }
              else {
                discountValue = discountValue + (value.itemPrice * value.quantity * nonDscDiscountPercentage) / 100;
                if (taxable) {
                  taxableDiscountAmount = taxableDiscountAmount + (value.itemPrice * value.quantity * nonDscDiscountPercentage) / 100;
                }
              }
            }

          });
        });
        // console.log('-----------App calculated Discount Amount -----------'+discountValue);
        // console.log('-----------App calculated Taxable  Discount Amount -----------'+taxableDiscountAmount);
        // console.log('-----------Server Calculated Discount Amount -----------'+discountInfo.couponAmount);
        // console.log('-----------Server Calculated Taxable Discount Amount -----------'+discountInfo.discountTaxable); 
        if (type === 'discount') {
          return discountValue;
        }
        if (type === 'taxableDiscount') {
          return taxableDiscountAmount;
        }
        break;
      default: return 1;

    }
  }
  generateDiscountValidityMsg(status) {
    this.discountCouponStatus = null;
    this.cError = false;
    if (status) return;
    else if (this.isDiscountCouponValid === false) {
      this.cError = true;
      this.discountCouponStatus = 'Invalid Code';
    }
    if (this.isDiscountCouponEnabled === false) {
      this.cError = true;
      return this.discountCouponStatus = 'Invalid Code';
    }
    if (this.isDiscountCouponExpired === true) {
      this.cError = true;
      return this.discountCouponStatus = 'This Code  was expired.';
    }
    if (!this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
      this.cError = true;
      return this.discountCouponStatus = "Promo Code cannot be used to purchase a DSC membership or GiftCard.  Please add more product to use a Promo code.";
    }
    if (this.isValidToApplyPromo && this.isDiscountCouponValid === true && !this.isDiscountTotalNegative) {
      this.discountCouponStatus = 'Successfully Applied';
    }
    else if (this.isDiscountCouponValid === false) {
      this.cError = true;
      this.discountCouponStatus = 'Invalid Code';
    }
    else if (this.isDiscountTotalNegative && this.isDiscountCouponValid) {
      this.cError = true;
      this.discountCouponStatus = 'Your Subtotal Amount should be more than the Discount Code amount';
    }
    else {

      this.discountCouponStatus = null;
    }
    return this.discountCouponStatus;
  }

  changeAddress() {
    var subScribedInfo = this.$auth.getSubscribedInfo();
    if (subScribedInfo && subScribedInfo.addressChange) {
      subScribedInfo.addressChange = false;
      this.$auth.setSubscribedInfo(subScribedInfo);
    }
    this.$state.go('delivery.address');
  }

  isFreeShippingOfferAvailable() {
    if (this.profile && this.cartDetail.freeshipping) {
      var shippingOfferStartDate = new Date(this.cartDetail.freeshipping.startDate);
      var shippingOfferEndDate = new Date(this.cartDetail.freeshipping.endDate);
      var currentDate = new Date();
      var result = false;
      if (this.profile.store) {
        if (this.profile.store.isFreeShipping) {
          if (currentDate >= shippingOfferStartDate && currentDate <= shippingOfferEndDate) {
            result = true;
          }
        }
      }

    }
    return result;
  }

  getFreeShippingRemainingAmount() {
    if (this.cartDetail) {
      if (this.cartDetail.freeshipping) {
        this.shippingOffer.thresholdAmount = this.cartDetail.freeshipping.thresholdValue;
      }
    }
    let remainingAmount = this.shippingGrossPrice() - this.shippingOffer.thresholdAmount;
    if (remainingAmount >= 0) {
      this.shippingOffer.isOfferEligible = true;
    }
    else {
      this.shippingOffer.isOfferEligible = false;
    }
    return remainingAmount * -1;
  }
  showFreeShippingOfferDetail() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free Shipping within Zone 2';
    }
    else {
      tittle = 'Free Shipping within Zone 2';
      detailInfo = '<p><ul><li>Offer available within Zone 2 shipping, approximately 150 miles from store. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to U.S. Addresses only.</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + tittle + '</h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  showFreeShippingOfferDetailCan() {
    var $ctrl = this;
    var detailInfo, tittle = '';
    if ($ctrl.shippingOffer.isOfferEligible) {
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
      tittle = 'Free shipping in Zones 0-1';
    }
    else {
      tittle = 'Free shipping in Zones 0-1';
      detailInfo = '<p><ul><li>Offer is valid within Zones 0-1 as defined by FedEx. Additional zones will incur additional charges.</li><li>Offer is valid only on orders placed at MyWBU Store, is limited to stock on hand, and is not redeemable for cash.</li><li>Offer limited to standard shipping to Canadian addresses only</li><li>Offer is valid on all orders with a subtotal of $' + $ctrl.shippingOffer.thresholdAmount + ' or more after any other discounts applied.</li></ul></p>';
    }
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + tittle + '</h5>' +
        detailInfo +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance',
        function ($scope, $order, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

  getSubtotal() {
    let totalPrice = 0;
    if(this.profile.store.hasErply){
      totalPrice = this.erplyShop.subTotal; // subtotal has promotions and BB discounted
    }
    else {
      if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired &&
        this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
          var maxPrice = 0;
          var maxPriceId = 0;
          var isDscMember = this.isDscMember() || this.cartContainsDsc();
          angular.forEach(this.cartDetail.cartItems, function (item, key) {
            // console.log(key);
            if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
              maxPriceId = item.item.id;
              maxPrice = item.item.price;
            }
          });
  
          angular.forEach(this.cartDetail.cartItems, function (item, key) {
            // console.log(key);
            if (maxPriceId === item.item.id) {
              if (item.subCategory.category.dscCategory && isDscMember) {
                totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * (item.quantity - 1));
              }
              else {
                totalPrice = totalPrice + (item.item.price * (item.quantity - 1));
              }
  
              totalPrice = totalPrice + item.item.price;
            }
            else {
              if (item.subCategory.category.dscCategory && isDscMember) {
                totalPrice = totalPrice + ((Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity);
              }
              else {
                totalPrice = totalPrice + (item.item.price * item.quantity);
              }
            }
          });
  
        }
      }
      else {
        if (this.isDscMember() || this.cartContainsDsc()) {
          let dscItems = this.cartDetail.cartItems.filter(item => item.subCategory.category.dscCategory);
          let dscTotal = dscItems.map(item => (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity)
            .reduce((prev, curr) => prev + curr, 0);
          let nondscItems = this.cartDetail.cartItems.filter(item => !item.subCategory.category.dscCategory);
          let nonDscTotal = nondscItems.map(item => item.item.price * item.quantity)
            .reduce((prev, curr) => prev + curr, 0);
          totalPrice = dscTotal + nonDscTotal;
        }
        else {
          totalPrice = this.totalRetailPrice();
        }
      }
    }
    return totalPrice;
  }

  totalRetailPrice() {
    return this.cartDetail.cartItems.map(item => item.item.price * item.quantity)
      .reduce((prev, curr) => prev + curr);
  }

  getClubPoints() {
    // console.log(this.storeDiscountMap);
    let points = 0;
    let tempPoints = 0;
    if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
      points = this.getPoints(this.storeDiscountMap);
    }
    else {
      tempPoints = this.getPoints(this.storeDiscountMap);
      if (tempPoints >= this.discountCouponAmount) {
        points = tempPoints - this.discountCouponAmount;
      } else {
        points = tempPoints;
      }
    }
    if (points >= this.couponAmount) {
      points = points - this.couponAmount;
    }
    return points;
  }

  getPoints(storeDiscountMap) {
    let points = 0;
    let dscTotal = 0;
    let nonDscTotal = 0;
    var $ctrl = this;
    // Update
    if (this.appliedDiscountCoupon && this.discountCoupon.enabled && !this.discountCoupon.expired && this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
      if (this.discountCoupon.discountType === 'HIGHPERCENTAGE') {
        let promoAmount = Math.round(this.discountCouponAmount * 100) / 100;
        var maxPrice = 0;
        var maxPriceId = 0;
        var isDscMember = this.isDscMember() || this.cartContainsDsc();
        angular.forEach(this.cartDetail.cartItems, function (item, key) {
          // console.log(key);
          if (item.item.masterProduct.isDiscountable && item.item.price > maxPrice) {
            maxPriceId = item.item.id;
            maxPrice = item.item.price;
          }
        });

        angular.forEach(this.cartDetail.cartItems, function (item, key) {
          // console.log(key);
          // console.log("High Percentage promo: Item id for " +maxPriceId + " Item Price : " + maxPrice);
          if (maxPriceId === item.item.id) {
            if (item.item.masterProduct.applyDscPoints) {
              if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
                if (item.subCategory.category.dscCategory) {
                  points = points + (Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100) * (item.quantity - 1);
                  points = points + (Math.round($ctrl.doubleTheValue(item.item.price - promoAmount) * 100) / 100);
                } else {
                  points = points + (Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100) * (item.quantity - 1);
                  points = points + (Math.round($ctrl.doubleTheValue(item.item.price - promoAmount) * 100) / 100);
                }
              }
              else {
                if (item.subCategory.category.dscCategory) {
                  points = points + (Math.round((0.85 * item.item.price) * 100) / 100) * (item.quantity - 1);
                  points = points + (item.item.price - promoAmount);
                } else {
                  points = points + (Math.round((item.item.price) * 100) / 100) * (item.quantity - 1);
                  points = points + (item.item.price - promoAmount);
                }
                // console.log("item ND"+item.item.name+" : "+item.item.subCategory.category.dscCategory + "Points: "+ points);
              }
            }
          } else {
            if (item.item.masterProduct.applyDscPoints) {
              if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
                if (item.subCategory.category.dscCategory) {
                  points = points + (Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100) * (item.quantity);
                } else {
                  points = points + (Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100) * (item.quantity);
                }
              }
              else {
                if (item.subCategory.category.dscCategory) {
                  points = points + (Math.round(0.85 * (item.item.price) * 100) / 100) * (item.quantity);
                } else {
                  points = points + (Math.round((item.item.price) * 100) / 100) * (item.quantity);
                }
              }
            }
          }
        });
      }
    } else {

      // Update end

      let dscItems = this.cartDetail.cartItems.filter(item => item.subCategory.category.dscCategory);
      dscItems.forEach(item => {
        // console.log(item.item.masterProduct.itemName +": "+ item.item.masterProduct.applyDscPoints);
        if (item.item.masterProduct.applyDscPoints) {
          if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
            dscTotal = dscTotal + (Math.round($ctrl.doubleTheValue(0.85 * item.item.price) * 100) / 100) * item.quantity;
          } else {
            dscTotal = dscTotal + (Math.round((0.85 * item.item.price) * 100) / 100) * item.quantity;
          }
        }
      }
      );

      let nondscItems = this.cartDetail.cartItems.filter(item => !item.subCategory.category.dscCategory);
      nondscItems.forEach(item => {
        if (item.item.masterProduct.applyDscPoints) {
          if (storeDiscountMap.status && item.item.masterProduct.applyDoubleDSCPoints) {
            nonDscTotal = nonDscTotal + (Math.round($ctrl.doubleTheValue(item.item.price) * 100) / 100) * item.quantity;
          } else {
            nonDscTotal = nonDscTotal + (Math.round((item.item.price) * 100) / 100) * item.quantity;
          }
        }
      }
      );
      points = dscTotal + nonDscTotal;
    }
    return points;
  }

  doubleTheValue(value) {
    return value * 2;
  }

  getDSCItemFromCart() {
    let dscItem = '';
    this.cartDetail.cartItems.forEach(item => {
      if (item.item.masterProduct.masterCode === this.dscMasterCode) {
        dscItem = item.item;
      }
    });
    return dscItem;
  }

  getGiftCardItemFromCart() {
    let giftCardItem = '';
    this.cartDetail.cartItems.forEach(item => {
      if (item.item.masterProduct.masterCode.charAt(0) === '9') {
        giftCardItem = item.item;
      }
    });
    // console.log('giftCardItem',giftCardItem);
    return giftCardItem;

  }

  getTotalGiftCardsCountFromCart() {
    let giftCardItem = 0;

    this.cartDetail.cartItems.forEach(item => {
      if (item.item.masterProduct.masterCode.charAt(0) === '9') {
        giftCardItem = giftCardItem + 1;
      }
    });

    return giftCardItem;
  }

  removePromoCookies() {
    try {
      sessionStorage.removeItem('discountCoupon');
    }
    catch (e) {
      this.$cookies.remove('discountCoupon');
    }
  }

  removeBBCookies() {
    try {
      sessionStorage.removeItem('birdbuckCoupon');
    }
    catch (e) {
      this.$cookies.remove('birdbuckCoupon');
    }
  }

  getClubPointsOld() {
    return this.orderPoints.dscPoints;
    // return 12;
  }
  calculateClubPoints() {
    this.appliedDiscountCoupon = sessionStorage.getItem('discountCoupon');
    this.appliedBirdBuckCoupon = sessionStorage.getItem('birdbuckCoupon');
    var isInStorePickUp = true;
    var shipToStateId;
    if(this.mode!==''){
      isInStorePickUp = this.mode===this.inStoreDelivery?true:false;
      shipToStateId = this.getShipToStateId(isInStorePickUp);
    } else {
      shipToStateId = this.getShipToStateId(true);
    }
    var data = {
      'bbcouponId': this.appliedBirdBuckCoupon ? this.appliedBirdBuckCoupon : null,
      'discountcoupon': this.appliedDiscountCoupon ? this.appliedDiscountCoupon : null,
      'isInStorePickUp': isInStorePickUp,
      'shipToStateId' : shipToStateId
    };
    
    this.$order.getOrderPoints(data);
  }

  // This method is used to reduce the totalAmount for calculation bbDiscount to be dutucted in taxableAmount
  detuctTotalDscMemberAndGiftAmount(){
    var amountToExclude = 0.00;
    var ctrl = this;
    this.cartItemTaxDetails.forEach(item => {
      if (item.item.masterProduct.masterCode.charAt(0) === '9' || 
      item.item.masterProduct.masterCode === this.dscMasterCode ) {
       var taxable = ctrl.getCheckForShippingTaxable(item);
        if(!taxable){
          amountToExclude=amountToExclude+(item.item.price* item.quantity);
        }
      }
    });
    return amountToExclude;
  }

   getTaxDetailRequest(isBBApplied) {
    let isInStorePickUP = true;
    if(this.mode === '' || this.mode === this.inStoreDelivery ) {
      isInStorePickUP = true;
    } else {
      isInStorePickUP = false;
    }
    //
    if(!isBBApplied){
      this.setSelectedBBCoupons();
    }
    //
    var data = {
      'shipTo': {
        'name': this.addressDetail.customer.firstName + this.addressDetail.customer.lastName,
        'addressLine1': this.addressDetail.shippingAddressLine1,
        'addressLine2': this.addressDetail.shippingAddressLine2,
        'city': this.addressDetail.shippingCity,
        'state': this.addressDetail.shippingState,
        'country': this.addressDetail.shippingCountry,
        'zip': this.addressDetail.shippingZipCode,
        'addressType': 'Shipping',
        'deliveryType': this.mode,
        'expectedDeliveryTime': '',
        'estimatedDeliveryDateTime': '',
        'phoneNumber': this.addressDetail.phoneNumber
      },
      'isInStorePickUP': isInStorePickUP,
      // 'shippingCharge': +(this.getSelectedShipmentCharge()).toFixed(2) || 0,
      // 'shippingDiscount': +this.getShippingDiscountCharge().toFixed(2),
      'shippingCharge':+this.getSelectedShipmentCharge()?(this.getSelectedShipmentCharge()).toFixed(2)||0:0,
      'shippingDiscount': +this.getShippingDiscountCharge()? this.getShippingDiscountCharge().toFixed(2) : 0,
      "couponIdentifiers" : [],
      "manualPromotionIDs" : []
    };

    if(this.example1model!=null && this.example1model.length>=1){
      angular.forEach(this.example1model, function (item, key) {
        if(item!=null && item.label!=null){
          data.couponIdentifiers.push(item.label);
        }
       });
    }

    if(this.discountCouponCode!=null){
      data.manualPromotionIDs.push(this.discountCouponCode);
    } else if(this.mobileDiscountCoupon!=null){
      data.manualPromotionIDs.push(this.mobileDiscountCoupon);
    }
    return data;
  }

  getCheckForShippingTaxable(value){
    var taxable = false;
    if(this.checkForShippingTaxable){
      taxable = value.item.shippingTaxableForState;
    } else {
      taxable = value.item.taxable;
    }
    return taxable;
  }

  applyDiscounts(isDiscountApplied, isBBApplied){
    // this.removeFreeItems();
    var $ctrl=this;
    // if(isDiscountApplied){
    //   if(this.discountCouponCode || this.mobileDiscountCoupon){
    //     $ctrl.erplyCampaignStatus =  'Promotion Applied automatically';
    //     $ctrl.isErplyCampaignValid = true;
    //   } else {
    //     $ctrl.erplyCampaignStatus =  'Invalid Code';
    //     $ctrl.isErplyCampaignValid = false;
    //   }
    //   return;
    // }
    
   
    // starts - new changes
    // this.avalaraResolveAddress(this.profile, this.profile.store, 2,isDiscountApplied, isBBApplied);
    if(this.mode === this.nextDayDelivery && this.profile.store.validateAddressType !== 'NOT_VALIDATE' && 
    this.profile.store.validateAddressType != this.profile.validatedAddressType) {
      this.$spinner.show('appSpinner');
      this.$auth.avalaraResolveAddress(this.profile, this.profile.store)
      .then( resolveAddress => {
          console.log("ResolveAddress : ", resolveAddress);
          this.$spinner.hide('appSpinner');
          this.$auth.openPopUpForAddressResolve(this.profile,resolveAddress, 
            addResolved => {
              this.isAddressValidated=true;
              
              console.log("Call back function", addResolved);
              if(addResolved.isCanceled){
                console.log("Canceled");
                this.changeAddress();
              } else {
                this.setTempDeliveryAddress(addResolved);
                this.calculateDiscounts(isDiscountApplied, isBBApplied);
              }
            });
      })
      .catch(err => {
        this.isAddressValidated=true;
        this.$spinner.hide('appSpinner');
        console.log("Error in edit : ", err);
        this.$auth.printCustomerGenericLogs(err);
      });
    } else {
      this.calculateDiscounts(isDiscountApplied, isBBApplied);
    }
  }

  getDeliveryMode(){
    var isInStorePickUp = true;
    if(this.mode!==''){
      isInStorePickUp = this.mode==='In Store Pickup'?true:false;
    } else {
      this.mode = "In Store Pickup";
      this.resetDeliveryMode(this.mode);
    }
    return isInStorePickUp;
  }

  setErplyBBDiscountCookie(erplyShop){
    try {
      sessionStorage.setItem('erplyBBDiscount', erplyShop.erplyBBDiscount);
      sessionStorage.setItem('erplyBBCouponCodes', erplyShop.usedBirdBuckcoupons);
    }
    catch (e) {
      this.$cookies.put('erplyBBDiscount', erplyShop.erplyBBDiscount);
      this.$cookies.put('erplyBBCouponCodes', erplyShop.usedBirdBuckcoupons);
    }
  }

  setErplyPromotionCookie(erplyShop){
    try {
      sessionStorage.setItem('erplyPromotionDiscount', erplyShop.erplyPromotionDiscount);
      sessionStorage.setItem('erplyPromotionCodes', erplyShop.manuallyAppliedPromotions);
    }
    catch (e) {
      this.$cookies.put('erplyPromotionDiscount', erplyShop.erplyPromotionDiscount);
      this.$cookies.put('erplyPromotionCodes', erplyShop.manuallyAppliedPromotions);
    }
  }

  removeErplyBBDiscountCookie(){
    try {
      sessionStorage.removeItem('erplyBBDiscount');
      sessionStorage.removeItem('erplyBBCouponCodes');
    }
    catch (e) {
      this.$cookies.remove('erplyBBDiscount');
      this.$cookies.remove('erplyBBCouponCodes');
    }
  }

  removeErplyPromotionCookie(){
    try {
      sessionStorage.removeItem('erplyPromotionDiscount');
      sessionStorage.removeItem('erplyPromotionCodes');
    }
    catch (e) {
      this.$cookies.remove('erplyPromotionDiscount');
      this.$cookies.remove('erplyPromotionCodes');
    }
  }

  setSelectedBBCoupons(){
    if(this.appliedErplyBBDiscount){
      if(this.erplyBirdBucksList && this.erplyBirdBucksList.length>0){
        this.getAndSetSelectedErplyBBCoupons();
      } else {
        this.$order.getBirdBucksByUser(this.profile.userId).then(() => {
          this.getAndSetSelectedErplyBBCoupons();
        })
        .catch(err => {
          this.removeErplyBBDiscountCookie();
          this.$auth.printCustomerGenericLogs(err);
        });
      }
    }
  }

  getAndSetSelectedErplyBBCoupons(){
    var ctrl = this;
    var selectedBBcoupons = {};
    var usedErplyCoupons = [];
    if(ctrl.example1model.length<=0) {
      console.log("sessionStorage.getItem('erplyBBCouponCodes') : ",sessionStorage.getItem('erplyBBCouponCodes'));
      if(sessionStorage.getItem('erplyBBCouponCodes')) {
        usedErplyCoupons = sessionStorage.getItem('erplyBBCouponCodes').split(',');
      }
      
      angular.forEach(usedErplyCoupons, function (selectedBB, key) {
          selectedBBcoupons = ctrl.erplyBirdBucksList.filter(item => item.label == selectedBB);
          // console.log("Selected BB Coupons : ",selectedBBcoupons);
          console.log("Selected BB : ", ctrl.example1model);
          ctrl.example1model.push(selectedBBcoupons[0]);
      });
    }
    // console.log("Example1model : ",ctrl.example1model);
  }

  setErplyPromotionCodes() {
      var usedErplyCoupon = [];
      if(this.appliedErplyPromotionDiscount) {
        usedErplyCoupon = sessionStorage.getItem('erplyPromotionCodes').split(',');
        this.discountCouponCode = usedErplyCoupon[0];
        console.log("this.discountCouponCode : ",this.discountCouponCode);
      }
    }

  getDefaultDeliveryMode(){
    var mode;
    if(this.profile!=null && this.profile.store!=null && !this.profile.store.isInStorePickup) {
      mode=this.nextDayDelivery;
    } else {
      mode='';
    }
    return mode;
  }

  resetErplyBBAndPromotionCookies() {
    if(this.erplyShop) {
      if(this.erplyShop.erplyBBDiscount>0) {
        this.setErplyBBDiscountCookie(this.erplyShop);
        // this.$spinner.hide('appSpinner');
      } else {
        this.removeErplyBBDiscountCookie();
      }
      // Set Erply Promotions cookies
      if(this.erplyShop.erplyPromotionDiscount>0){
        this.setErplyPromotionCookie(this.erplyShop);
        // this.$spinner.hide('appSpinner');
      } else {
        this.removeErplyPromotionCookie();
      }
    }
  }

  getAndSetAppliedErplyBBCoupons(usedErplyCoupons) {
    var ctrl = this;
    var selectedBBcoupons = {};
    this.example1model=[];
    // if(ctrl.example1model.length<=0){
      if(usedErplyCoupons!="" && usedErplyCoupons.length>=1) {
          angular.forEach( usedErplyCoupons, function (selectedBB, key) {
            selectedBBcoupons = ctrl.erplyBirdBucksList.filter(item => item.label == selectedBB);
            // console.log("Selected BB Coupons : ",selectedBBcoupons);
            console.log("Selected BB : ", ctrl.example1model);
            console.log("selectedBBcoupons[0] : ",selectedBBcoupons[0]);
            if(selectedBBcoupons[0] && selectedBBcoupons[0]!=null){
              ctrl.example1model.push(selectedBBcoupons[0]);
            }
        });
      }
    // }
    // console.log("Example1model : ",ctrl.example1model);
  }

  orderNotesSession() {
    sessionStorage.setItem('orderNotesSession', this.orderNotes);
    console.log("orderNotesSession --- ",sessionStorage.getItem('orderNotesSession'));
  } 

  navigateCart() {
    this.$state.go('cart');
  }
  
  deliveryModechanges(mode, isCurbside = false) {
    if (mode !== this.nextDayDelivery) {
      this.resetDeliveryMode(mode);
      this.mode = mode;
      this.isCurbside = isCurbside;
      this.$rootScope.isCurbside = isCurbside;
      if (this.isCurbside) {
        this.getCurbsideDetails();
      }
      this.resetCouponValues();
      this.getTax();
    } else {
      this.isCurbside = false;
      this.$rootScope.isCurbside = false;
    }
  }

  getCurbsideDetails(fromSubmit = false) {
    var $ctrl = this;
    this.$uibModal.open({
      size: 'md',
      template: `<div class="modal-header modalheaderbg btn-primary"><h5>Curbside pickup details</h5></div>
        <div class="modal-body" id="modal-body">
          <div class="container-fluid"> 
            <div class="row"> 
              <form name="curbsideForm" ng-submit="submit(curbsideForm)" autocomplete="off" novalidate>
                <div class="col-md-12 error-text" ng-if="curbsideForm.error.message">{{curbsideForm.error.message}}</div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Car make/model/color * </label>
                      <input name="carName" type="text" required ng-model="carName" class="form-control"/>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                      <label>Phone Number * </label>
                      <input name="phNo" type="tel" required ui-mask="(999) 999-9999" ng-model="phNo" class="form-control"/>
                    </div>
                </div>
                <div class="col-md-12" style="margin-top: -3%;">
                    <div class="form-group">
                      <label>You will receive an email when your order is placed and a second email when your order is ready.</label><br/>
                      <strong>Store Instructions</strong><br/>
                      <label ng-bind="storeInstruction"></label>
                    </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-footer m-t-1">
            <button class="btn" type="button" ng-click="cancel()">Cancel</button>
            <button class="btn btn-primary m-l-1" type="button" ng-click="ok(curbsideForm)">Submit</button>
        </div>`,
      controller: ['$scope', '$uibModalInstance',
        function ($scope, $uibModalInstance) {
          $scope.phNo = $ctrl.profile.phoneNumber;
          $scope.storeInstruction = $ctrl.profile.store.curbSideInstruction;
          if ($ctrl.curbSideDetails) {
            $scope.carName = $ctrl.curbSideDetails.carName ? $ctrl.curbSideDetails.carName : "";
            $scope.phNo = $ctrl.curbSideDetails.phNo ? $ctrl.curbSideDetails.phNo : $scope.phNo;
          }
          // eslint-disable-next-line arrow-parens
          $scope.ok = (curbsideForm) => {
            if ($scope.carName && $scope.phNo) {
              $ctrl.curbSideDetails = {
                carName: $scope.carName ? $scope.carName : "",
                phNo: $scope.phNo ? $scope.phNo : ""
              };
              $ctrl.$rootScope.curbSideDetails = $ctrl.curbSideDetails;
              $uibModalInstance.close();
              if (fromSubmit) {
                $ctrl.submit();
              }
            } else {
              curbsideForm.error = {message: 'Please fill All details!'};
            }
          };
          $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel'); 
          };
        }
      ],
      backdrop: 'static',
      keyboard: false
    });
  }

  removeFreeItems() {
    if (this.discountCouponCode !== 'FREEITEM') {
      // Removing Free item when promo code removed
      if (this.orderPoints && this.orderPoints.discountWrapper && this.orderPoints.discountWrapper.cartItemset.length) {
        const findItem = this.orderPoints.discountWrapper.cartItemset.find(item => item.discountTypeApplied === 'FREEITEM' && item.isDiscountApplied);
        // Removing Free item when discount is removed
        if (findItem && findItem.item && findItem.discountTypeApplied === 'FREEITEM' && findItem.isDiscountApplied) {
          if (findItem.quantity === 1) {
            this.$order.removeItemFromCart(findItem.item.id);
          } else {
            this.$order.updateItemInCart(findItem.quantity - 1, findItem.item.id, findItem.item.masterProduct.subCategories[0].id);
          }
        }
      }
    }
  }


  avalaraResolveAddress(userDetail, store, Type, isDiscountApplied, isBBApplied) {
    userDetail.store = store;
    console.log("Calling Resolve address : ", userDetail);
    if(this.mode === this.nextDayDelivery && this.profile.store.validateAddressType !== 'NOT_VALIDATE' && 
    this.profile.store.validateAddressType != this.profile.validatedAddressType) {
          this.$auth.avalaraResolveAddress(userDetail, store)
          .then( success => {
              console.log("Success validating : ", success);
              var $ctrl = this;
              $ctrl.userDetail = userDetail;
              $ctrl.success = success;
              $ctrl.Type = Type;
              var modalInstance;
              if(success.data){
                modalInstance = this.$uibModal.open({
                  size: 'md',
                  template: '<div class="modal-header modalheaderbg btn-primary"><h5>Resolve Shipping Address</h5></div>' +
                    '<div class="modal-body" id="modal-body">' +
                    '<div class="container-fluid">' +
                    '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' +
                    '<div class="row">' +
            
                    `<div class="col-md-12">
                          <div class="col-md-12 mb-4" style="text-align: center;">
                            <h6><strong>From</strong></h6>
                          </div>
      
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : '')}}
                          </div>
                          </div>
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : '')}}
                          </div>
                          </div>
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">City</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingCity ? user.shippingCity.trim() : '')}}
                          </div>
                          </div>
      
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">State</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingState ? user.shippingState.code : '')}}
                          </div>
                          </div>
      
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">Zip</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingZipCode ? user.shippingZipCode.trim() : '')}}
                          </div>
                          </div>
      
                    </div>`
                    +
                    
                    `<div ng-if="isValidAddress">
                    <br>
                    <div class="col-md-12">
                    <div class="col-md-12 mb-4" style="text-align: center;">
                      <h6><strong>To</strong></h6>
                    </div>
      
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.addressLine1 ? selected.addressLine1.trim() : '')}}
                    </div>
                    </div>
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.addressLine2 ? selected.addressLine2.trim() : '')}}
                    </div>
                    </div>
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">City</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.city ? selected.city.trim() : '')}}
                    </div>
                    </div>
      
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">State</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.state ? selected.state.code : '')}}
                    </div>
                    </div>
      
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Zip</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.zip ? selected.zip.trim() : '')}}
                    </div>
                    </div>
                    </div>
                    </div>
  
                    <div class="col-md-12" ng-if="!isValidAddress">
                    <br>
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Given Address not Validated with our records</label>
                    </div>
                    <div class="col-md-7">
                      {{summary}}
                    </div>
                    </div>
                    ` +
  
                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button  ng-if="isValidAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Update</button>' +
                    '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;">Use this address anyway</button>' +
                    '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="fix()" style="float: right;">I will fix the address</button>' +
                    
                    '</div>',
                controller: ['$scope', '$state', '$uibModalInstance',
                  function ($scope, $state, $uibModalInstance) {
                    $scope.error = { message: '' };
                    $scope.user = $ctrl.userDetail;
                    $scope.isValidAddress = false;
                    $scope.count = 1;
                    if($ctrl.userDetail.store.validateAddressType==='BOTH_BILL_SHIP'){
                      $scope.count = 2;
                    }
                    if($ctrl.success.data.resolutionQuality==='Intersection') {
                      $scope.isValidAddress = true;
                      if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
                        $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
                      }
                      else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
                        $scope.selected = $ctrl.success.data.billingAddresstoResolve;
                      }
                    } else {
                      if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
                        $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
                        $scope.summary  = $ctrl.success.data.shippingAddresstoResolve.summary;
                      }
                      else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
                        $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
                        $scope.summary  = $ctrl.success.data.billingAddresstoResolve.summary;
                      }
                    }
                    $scope.submit = () => {
                      // $ctrl.$spinner.show('appSpinner');
                      console.log("It calls from submit");
                      $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
                      $ctrl.addressDetail.shippingAddressLine1 = $scope.selected.addressLine1;
                      $ctrl.addressDetail.shippingAddressLine2 = $scope.selected.addressLine2;
                      $ctrl.addressDetail.shippingCity =  $scope.selected.city;
                      $ctrl.addressDetail.shippingState = $scope.selected.state;
                      $ctrl.addressDetail.shippingCountry = $scope.selected.country;
                      $ctrl.addressDetail.shippingZipCode = $scope.selected.zip;
                      
                      $uibModalInstance.close($scope.user);
                    };
                    $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                    $scope.back = () => {
                      $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
                      $uibModalInstance.close($scope.user);
                    };
                    $scope.fix = () => {
                      console.log("In fixing ");
                      $uibModalInstance.dismiss('cancel');
                    };
                  }
                ],
                resolve: {
                }
              });
              modalInstance.result.then(function (data) {
                  console.log('user clicked ok', data);
                  if($ctrl.Type == 1){
                    $ctrl.calculateTaxes();
                  } else if($ctrl.Type == 2){
                    $ctrl.calculateDiscounts(isDiscountApplied, isBBApplied);
                  }
                  
              })
              .catch(err => {
                $ctrl.$auth.printCustomerGenericLogs(err);
              });
            }
          })
          .catch( error => {
            console.log("Didn't call service resolve address : ", error);
            this.$auth.printCustomerGenericLogs(error);
          });
        } else {
          if(Type == 1){
            this.calculateTaxes();
          } else if(Type == 2){
            this.calculateDiscounts();
          }
        }
  } 


  calculateTaxes() {
    this.$spinner.show('appSpinner');
    var shipToStateId;
    var isInStorePickUp = true;
    if(this.mode!==''){
      isInStorePickUp = this.mode===this.inStoreDelivery?true:false;
      shipToStateId = this.getShipToStateId(isInStorePickUp);
    } else {
      shipToStateId = this.getShipToStateId(true);
    }
    var ctrl = this;
    var taxableDiscountAmount = 0;
    var discountAmount = 0;
    var bbdiscount = 0;
    console.log("Calling calculate Taxes ");
    var taxDetailRequestData = this.getTaxDetailRequest();
    this.isCallingAPI = true;
        this.$order.getItemTaxDetails(taxDetailRequestData)
        .then(success => {
        this.isCallingAPI = false;
        this.cartItemTaxDetails = success.data.cartItems;
        this.checkForShippingTaxable = success.data.checkForShippingTaxable;
        if(this.profile.store.hasErply){
          this.erplyShop = success.data.showCart.erplyShopCartResponse;
          this.setErplyCartResponseValue(success.data.showCart);

          var usedErplyCoupons = this.erplyShop.usedBirdBuckcoupons.split(',');
          this.getAndSetAppliedErplyBBCoupons(usedErplyCoupons);

          this.resetErplyBBAndPromotionCookies(this.erplyShop);
          console.log("Checking for showcart error :  ", success.data.showCart);
          
          if(success.data && success.data.showCart && success.data.showCart.baseResponse 
            && taxDetailRequestData.manualPromotionIDs  && taxDetailRequestData.manualPromotionIDs.length>0){
            if(success.data.showCart.baseResponse.successCode=='200'   && this.erplyShop.isPromotionAppliedSuccessfuly){
              this.isErplyCampaignValid = true;
            } else {
              this.isErplyCampaignValid = false;
            }
            this.erplyCampaignStatus =  success.data.showCart.baseResponse.message;
          }
            // this.$spinner.hide('appSpinner');
          


          if(success.data.showCart.cartError.length>0){
            this.toaster.pop('success', 'Error in tax calculation'); 
            this.hasCartError = true;
          } else {
            this.hasCartError = false;
          }
          // this.setSelectedBBCoupons();
        } else {
          if (this.discountCouponAmount) {
            // this.checkDiscountCoupon({ $error: {}, $$success: {}, $pending: undefined, $name: "discountCouponForm", $dirty: false }, this.appliedDiscountCoupon, false);
            this.$order.getCouponDiscount(this.appliedDiscountCoupon,isInStorePickUp,shipToStateId)
             .then(success => {
            taxableDiscountAmount = ctrl.getDiscountValue(ctrl.discountCoupon, 'taxableDiscount');
            taxableDiscountAmount = Math.round(100 * taxableDiscountAmount) / 100;
            discountAmount = ctrl.getDiscountValue(ctrl.discountCoupon, 'discount');
            discountAmount = Math.round(100 * discountAmount) / 100;
            if (taxableDiscountAmount <= 0) {
              taxableDiscountAmount = 0;
            }
            this.calculateTaxUponBBandDiscount(taxableDiscountAmount,discountAmount);
           })
           .catch(err => {

            this.discountCoupon = null;
            this.isDiscountCouponValid = false;
            this.discountCouponID = null;
            this.discountCouponAmount = 0;
            this.appliedDiscountCoupon = null;
            this.discountCouponCode = null;
            this.mobileDiscountCoupon = null;
            this.taxableDiscountAmount = 0;
            this.discountCode = null;
            this.removePromoCookies();
            // this.getTax();
            this.generateDiscountValidityMsg();
    
            this.cError = true;
            this.discountCouponStatus = err.data.message;
    
          });
          } else {
            this.calculateTaxUponBBandDiscount(taxableDiscountAmount,discountAmount);
          }
        }
        this.$spinner.hide('appSpinner');
      },
      error => {
        this.isCallingAPI = false;
        this.$auth.printCustomerGenericLogs(error);
      }
    )
      .catch(err => {
        this.noItemsInCart = true;
        this.isCallingAPI = false;
        if(!this.profile.store.hasErply){
          this.calculateTaxUponBBandDiscount(taxableDiscountAmount,discountAmount);
        }
        this.$spinner.hide('appSpinner');
        this.$auth.printCustomerGenericLogs(err);
      });
  }


  isPromotionManaullyApplied(){
    // Check for erply store
      if(this.erplyShop!=null && this.erplyShop.manuallyAppliedPromotions!=null &&  
          this.erplyShop.manuallyAppliedPromotions.length>0) {
            return true;
      } else {
            return false;
      }
  }

  calculateDiscounts(isDiscountApplied, isBBApplied){

        if(this.mode===''){
          this.promptForDeliveryType('',"Please select an option for how to receive your order");
          // this.toaster.pop('success', 'Please choose how to receive your order!');
          return false;
        }
        this.$spinner.show('appSpinner');
        var $ctrl = this;
        var isInstorePickup = this.getDeliveryMode();
        var data = {
          "isDiscountApplied" : isDiscountApplied,
          "couponIdentifiers" : [],
          "manualPromotionIDs" : [],
          'shippingCharge': +this.getSelectedShipmentCharge()?(this.getSelectedShipmentCharge()).toFixed(2) || 0 : 0,
          'shippingDiscount': +this.getShippingDiscountCharge()? this.getShippingDiscountCharge().toFixed(2) : 0
        };
        if(isInstorePickup){
          data.shippingCharge=0;
          data.shippingDiscount=0;
        } else {
          data.shippingCharge=+this.getSelectedShipmentCharge()?(this.getSelectedShipmentCharge()).toFixed(2)||0:0;
          data.shippingDiscount=+this.getShippingDiscountCharge()? this.getShippingDiscountCharge().toFixed(2) : 0;
        }
    
        if(this.example1model.length>0){
          console.log("this.examplemodel : ", this.example1model);
          angular.forEach(this.example1model, function (item, key) {
            // console.log("this.examplemodel each: ", item);
            if(item!=null && item.label!=null){
              data.couponIdentifiers.push(item.label);
            }
           });
        }
        if(this.discountCouponCode!=null){
          data.manualPromotionIDs.push(this.discountCouponCode);
        }
        console.log("Multiple BB : ",data);
        
        var taxDetailRequestData = this.getTaxDetailRequest(isBBApplied);
        this.$order.getItemTaxDetails(taxDetailRequestData)
        .then(success => {
        this.cartItemTaxDetails = success.data.cartItems;
        this.checkForShippingTaxable = success.data.checkForShippingTaxable;
        if(this.profile.store.hasErply){
          this.erplyShop = success.data.showCart.erplyShopCartResponse;
          // Set BirdBuck cookies
        this.setErplyCartResponseValue(success.data.showCart);
        this.resetErplyBBAndPromotionCookies(this.erplyShop);
        }
        if(isDiscountApplied){
          if(success.data && success.data.showCart && success.data.showCart.baseResponse){
            if(success.data.showCart.baseResponse.successCode=='200'  && this.erplyShop.isPromotionAppliedSuccessfuly){
              $ctrl.isErplyCampaignValid = true;
            } else {
              this.appliedDiscountCoupon = null;
              this.mobileDiscountCoupon = null;
              this.discountCouponCode = null;
              $ctrl.isErplyCampaignValid = false;
            }
            $ctrl.erplyCampaignStatus =  success.data.showCart.baseResponse.message;
          } else {
            $ctrl.erplyCampaignStatus = "";
          }
          // this.$spinner.hide('appSpinner');
        }
        if(isBBApplied){


          if(success.data && success.data.showCart && success.data.showCart.baseResponse){
            if(success.data.showCart.baseResponse.successCode=='200'  && this.erplyShop.isPromotionAppliedSuccessfuly){
              $ctrl.isErplyCampaignValid = true;
            } else {
              this.appliedDiscountCoupon = null;
              this.mobileDiscountCoupon = null;
              this.discountCouponCode = null;
              $ctrl.isErplyCampaignValid = false;
            }
            $ctrl.erplyCampaignStatus =  success.data.showCart.baseResponse.message;
          }else {
            $ctrl.erplyCampaignStatus = "";
          }


          if( $ctrl.erplyShop.erplyBBDiscount>0){
            var usedErplyCoupons = $ctrl.erplyShop.usedBirdBuckcoupons.split(',');
            $ctrl.getAndSetAppliedErplyBBCoupons(usedErplyCoupons);
            $ctrl.resetErplyBBAndPromotionCookies();
            $ctrl.couponStatus = 'Successfully Applied';
            $ctrl.isCouponValid = true;
            $ctrl.isTotalNegative = false;
          } else {
            this.example1model=[];
            this.removeErplyBBDiscountCookie();
            $ctrl.couponStatus = '';
            $ctrl.isCouponValid = false;
            $ctrl.isTotalNegative = true;
          }
        }
        this.$spinner.hide('appSpinner');
      }
    )
      .catch(err => {
        this.noItemsInCart = true;
        this.removeErplyBBDiscountCookie();
        this.$spinner.hide('appSpinner');
        this.$auth.printCustomerGenericLogs(err);
        // this.calculateTaxUponBBandDiscount(taxableDiscountAmount,discountAmount);
      });
  }



  getStates(country, type ,time) {
    // console.log(country);
    // console.log(type);
    switch (type) {
      case 'billingAddress':
        if (this.profile && time !== 0) {
          if (this.profile.billingState) {
            this.profile.billingState.code = '';
            this.profile.billingZipCode = '';
          }
        }
        var billingStates = '';
        // console.log(this.billingCountries);
        angular.forEach(this.billingCountries, function(value) {
         
          
          if (country === value.label) {
            billingStates = value.states;
          }
        });

        this.billingStates = billingStates;
        break;
      case 'shippingAddress':
      if (this.profile && time !== 0) {
        if (this.profile.shippingState) {
          this.profile.shippingState.code = '';
          this.profile.shippingZipCode = '';
        }
      }
      var shippingStates = '';
      // console.log(this.shippingCountries);
      angular.forEach(this.shippingCountries, function(value) {
        // console.log(country,"==",value.label);
        if (country === value.label) {
          shippingStates = value.states;
        }
      });
      
      this.shippingStates = shippingStates;
        break;
      default: 
        break;

    }
  }

  promptForDeliveryType(title,detail){
      
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">' + title + '</h5>' +
        // '<span ng-bind-html="'+detailed+'" > </span>'+
        detail +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '</div>',
      controller: ['$scope', '$uibModalInstance',
        function ($scope, $uibModalInstance) {

          $scope.ok = () => {
            $uibModalInstance.close();

          };

        }
      ]
    });
  }

    setTempDeliveryAddress(addResolved){
      console.log("AddResolved : " , addResolved);
      console.log("AddResolved.shippingAddressLine1 : " , addResolved.shippingAddressLine1);
      this.addressDetail.shippingAddressLine1 = addResolved.shippingAddressLine1;
      this.addressDetail.shippingAddressLine2 = addResolved.shippingAddressLine2;
      this.addressDetail.shippingCity = addResolved.shippingCity;
      this.addressDetail.shippingZipCode = addResolved.shippingZipCode;
      var country = '';
      var state = '';
      angular.forEach(this.shippingCountries, function(country1) {
            if (addResolved.shippingCountry.countryCode === country1.label) {
            country = {
              "id": parseInt(country1.value),
              "countryCode":country1.label,
              "name": country1.name
            };
            angular.forEach(country1.states, function(state1) {
              if (addResolved.shippingState.code === state1.value) {
                state = {
                  "id": state1.id,
                  "code": state1.value,
                  "name": state1.label
                };
              }
            });
          }
        });
        this.addressDetail.shippingCountry=country;
        this.addressDetail.shippingState=state;
        localStorage.setItem('deliveryAddress', JSON.stringify(this.addressDetail));
    }
    
    infoPopup() {
      document.getElementById('popup').style.display = 'block';
      setTimeout(() => {
       if (document.getElementById('popup').style.display === 'block' && this.showPopup === false) {
        this.hideinfoPopup();
       }
       }, 5000);
    }
    hideinfoPopup() {
      document.getElementById('popup').style.display = 'none';
      this.showPopup = false;
    }
    infoPopuponhover() {
      document.getElementById('popup').style.display = 'block';
      this.showPopup = true;
    }
    infoPopupFee() {
      document.getElementById('popup1').style.display = 'block';
      setTimeout(() => {
       if (document.getElementById('popup1').style.display === 'block' && this.showPopupFee === false) {
        this.hideinfoPopupFee();
       }
       }, 5000);
    }
    hideinfoPopupFee() {
      document.getElementById('popup1').style.display = 'none';
      this.showPopupFee = false;
    }
    infoPopuponhoverFee() {
      document.getElementById('popup1').style.display = 'block';
      this.showPopupFee = true;
    }

    setErplyCartResponseValue(showcart) {
      console.log("Showcart : ", showcart);
      this.erplyDis = [];
      var dis ={};
      var ctrl = this;
      var i = 0;
      angular.forEach(showcart.erplyPromoAndDiscount, function (item,key) {
        console.log('key', key);
        console.log('item', item);
        dis ={};
        dis.key = key;
        dis.value = item;
        dis.sortId = i+1;
        i=i+1;
        ctrl.erplyDis.push(dis);
      });
    }

    getAdjustedLabelName(promoLabel) {
      if(promoLabel!=null && promoLabel.length>this.promoLengthToBeShown){
        return promoLabel.substring(0, this.promoLengthToBeShown-3)+"...";
      } else {
        return promoLabel;
      }
    }
  
    hideinfoPromoNamePopup(prefix,index, itemName, promoName) {
      var divId = "";
      if(itemName!=null){
        divId = prefix+''+index+''+itemName+''+promoName;
      } else {
        divId =prefix+''+index+''+ promoName;
      }
      document.getElementById(divId).style.display = 'none';
      this.showPopup = false;
    }
  
    infoPopupPromoNameonhover(prefix,index, itemName, promoName) {
      var divId = "";
      if(itemName!=null){
        divId = prefix+''+index+''+itemName+''+promoName;
      } else {
        divId =prefix+''+index+''+ promoName;
      }
      document.getElementById(divId).style.display = 'block';
      this.showPopup = true;
    }

}




// WEBPACK FOOTER //
// ./src/app/order/delivery/delivery.js